var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlyAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.201 68.841H404.985C403.773 68.841 402.574 68.6023 401.455 68.1383C400.336 67.6744 399.32 66.9945 398.464 66.1374C397.608 65.2803 396.929 64.2629 396.467 63.1434C396.004 62.0238 395.767 60.8241 395.769 59.6128V58.9919C395.769 56.5444 394.796 54.1972 393.066 52.4666C391.335 50.7359 388.988 49.7637 386.54 49.7637H323.526C321.079 49.7669 318.734 50.7402 317.004 52.4701C315.274 54.2 314.3 56.5454 314.297 58.9919V60.2094C314.286 61.4284 314.516 62.6375 314.975 63.767C315.434 64.8965 316.112 65.9239 316.97 66.7899C317.828 67.6558 318.849 68.3432 319.974 68.8123C321.099 69.2814 322.306 69.5229 323.526 69.5228H332.62C335.063 69.5131 337.411 70.4727 339.147 72.1912C340.884 73.9098 341.868 76.2469 341.885 78.6902C341.885 79.9015 341.646 81.1009 341.182 82.2198C340.718 83.3388 340.038 84.3553 339.181 85.2112C338.324 86.0672 337.306 86.7458 336.187 87.2082C335.067 87.6706 333.868 87.9078 332.656 87.9062H323.562C321.115 87.9062 318.767 88.8785 317.037 90.6091C315.306 92.3397 314.334 94.687 314.334 97.1345V98.3519C314.334 100.799 315.306 103.147 317.037 104.877C318.767 106.608 321.115 107.58 323.562 107.58H367.39C369.838 107.58 372.185 106.608 373.915 104.877C375.646 103.147 376.618 100.799 376.618 98.3519V97.731C376.624 95.3108 377.581 92.9898 379.282 91.2682C380.983 89.5466 383.293 88.5622 385.713 88.5271H421.165C422.383 88.5336 423.591 88.2983 424.718 87.835C425.845 87.3717 426.869 86.6895 427.73 85.8279C428.592 84.9663 429.274 83.9424 429.737 82.8155C430.201 81.6885 430.436 80.4808 430.429 79.2624V78.0449C430.428 76.8347 430.188 75.6366 429.723 74.519C429.259 73.4015 428.578 72.3864 427.721 71.5317C426.865 70.6771 425.848 69.9996 424.729 69.5379C423.61 69.0762 422.411 68.8394 421.201 68.841Z",
    fill: "#C0D1ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M439.839 164.485V103.771L421.785 90.3788V132.989H421.188H417.962C413.387 132.989 408.999 134.807 405.763 138.042C402.528 141.277 400.711 145.665 400.711 150.241V166.92L388.256 162.512L378.687 166.323L371.918 164.485V136.8C373.193 135.681 374.213 134.303 374.912 132.757C375.612 131.212 375.973 129.536 375.972 127.84C375.991 125.327 375.205 122.875 373.731 120.84C372.257 118.805 370.172 117.295 367.779 116.529V104.428C369.185 103.692 370.332 102.542 371.065 101.135C371.798 99.7268 372.083 98.1282 371.88 96.5539C371.677 94.9796 370.996 93.5053 369.93 92.3295C368.864 91.1536 367.463 90.3326 365.916 89.977V80.6514C366.72 80.3295 367.409 79.7742 367.895 79.057C368.38 78.3398 368.639 77.4937 368.639 76.6277C368.639 75.7617 368.38 74.9156 367.895 74.1984C367.409 73.4812 366.72 72.9259 365.916 72.6041V63.5584C365.913 63.3783 365.874 63.2006 365.802 63.0356C365.73 62.8705 365.626 62.7215 365.495 62.5969C365.365 62.4724 365.212 62.3749 365.044 62.3101C364.875 62.2453 364.696 62.2144 364.516 62.2192H364.26C363.899 62.2192 363.552 62.3629 363.296 62.6186C363.041 62.8743 362.897 63.2212 362.897 63.5828V72.6284C362.093 72.9503 361.404 73.5056 360.918 74.2227C360.433 74.9399 360.174 75.7861 360.174 76.6521C360.174 77.5181 360.433 78.3642 360.918 79.0814C361.404 79.7985 362.093 80.3539 362.897 80.6757V89.977C361.35 90.3326 359.949 91.1536 358.883 92.3295C357.817 93.5053 357.136 94.9796 356.933 96.5539C356.73 98.1282 357.015 99.7268 357.748 101.135C358.481 102.542 359.628 103.692 361.034 104.428V116.529C359.042 117.189 357.259 118.361 355.864 119.928C354.47 121.496 353.512 123.403 353.089 125.458C352.666 127.513 352.791 129.643 353.453 131.634C354.115 133.626 355.289 135.407 356.858 136.8V160.345L348.166 157.91V198.232H342.456V127.84L324.194 132.855V116.529L306.14 103.138V137.81L298.433 139.917V124.552C298.43 123.522 298.02 122.535 297.293 121.805C296.566 121.076 295.58 120.663 294.55 120.657H293.819C292.785 120.66 291.794 121.073 291.064 121.806C290.333 122.538 289.923 123.53 289.923 124.565V198.293H282.229V101.628H278.698V94.7129H270.919V68.4526C270.919 67.4161 270.507 66.4221 269.774 65.6892C269.041 64.9563 268.047 64.5446 267.011 64.5446H266.28C265.246 64.5478 264.255 64.9609 263.525 65.6935C262.795 66.426 262.385 67.4182 262.385 68.4526V94.7129H257.357V77.5104C257.358 76.9977 257.259 76.4898 257.064 76.0157C256.868 75.5417 256.582 75.1108 256.22 74.7477C255.858 74.3847 255.428 74.0966 254.954 73.9001C254.481 73.7035 253.973 73.6024 253.461 73.6024H252.73C251.694 73.6024 250.7 74.0141 249.967 74.747C249.234 75.4799 248.822 76.4739 248.822 77.5104V94.7129H227.444V101.628H223.926V158.178H218.739V123.725L206.565 137.116V158.203H199.26V83.6098C199.26 83.2481 199.116 82.9013 198.861 82.6456C198.605 82.3899 198.258 82.2462 197.897 82.2462H197.641C197.279 82.2462 196.932 82.3899 196.677 82.6456C196.421 82.9013 196.277 83.2481 196.277 83.6098V158.178H193.185V98.8887C193.182 98.4312 192.999 97.9933 192.675 97.6698C192.352 97.3463 191.914 97.1631 191.456 97.1599H189.703C189.245 97.1599 188.805 97.3421 188.481 97.6663C188.156 97.9905 187.974 98.4302 187.974 98.8887V158.178H184.322V198.281H180.56V144.543C180.557 143.509 180.144 142.518 179.411 141.787C178.679 141.057 177.686 140.647 176.652 140.647H175.922C175.507 140.654 175.096 140.728 174.704 140.866V81.7714L162.53 95.1633V124.309C161.926 123.973 161.248 123.793 160.557 123.785C160.225 123.793 159.894 123.837 159.571 123.919L154.251 103.783C154.1 103.186 153.755 102.657 153.27 102.278C152.785 101.899 152.188 101.692 151.573 101.689H149.138V95.7599H150.173L144.889 63.5584C144.852 63.3204 144.731 63.1036 144.548 62.947C144.365 62.7904 144.132 62.7043 143.891 62.7043C143.65 62.7043 143.417 62.7904 143.234 62.947C143.051 63.1036 142.93 63.3204 142.892 63.5584L137.584 95.7599H138.57V101.628H136.136C135.52 101.631 134.923 101.838 134.438 102.217C133.953 102.596 133.608 103.125 133.457 103.722L128.137 123.858C127.814 123.777 127.484 123.732 127.151 123.725C126.056 123.74 125.009 124.175 124.227 124.941C123.445 125.708 122.988 126.745 122.951 127.84H122.744C121.911 127.84 121.112 128.17 120.523 128.76C119.934 129.349 119.603 130.148 119.603 130.981V158.178L112.614 161.331V136.678L100.428 141.353V166.822L93.4397 169.987V136.885C93.4375 136.263 93.2873 135.651 93.0016 135.098C92.7158 134.545 92.3026 134.069 91.7962 133.708C92.4828 133.151 92.9819 132.397 93.2257 131.548C93.4696 130.699 93.4464 129.795 93.1594 128.959C92.8724 128.123 92.3354 127.396 91.6212 126.876C90.907 126.355 90.05 126.067 89.1665 126.05C88.0384 126.075 86.9666 126.547 86.186 127.362C85.4055 128.177 84.98 129.268 85.0028 130.396C85.0018 131.038 85.1446 131.672 85.4206 132.251C85.6965 132.83 86.0988 133.341 86.5977 133.744C86.0913 134.105 85.6781 134.582 85.3923 135.135C85.1065 135.687 84.9563 136.3 84.9541 136.922V173.445L78.4286 171.144V136.885C78.4264 136.263 78.2762 135.651 77.9904 135.098C77.7047 134.545 77.2915 134.069 76.7851 133.708C77.4725 133.163 77.9734 132.418 78.2182 131.576C78.4629 130.733 78.4395 129.836 78.1511 129.007C77.8628 128.179 77.3237 127.461 76.6088 126.953C75.8939 126.445 75.0386 126.172 74.1615 126.172C73.2844 126.172 72.4291 126.445 71.7142 126.953C70.9993 127.461 70.4602 128.179 70.1718 129.007C69.8835 129.836 69.86 130.733 70.1048 131.576C70.3496 132.418 70.8505 133.163 71.5379 133.708C71.03 134.067 70.6158 134.544 70.3298 135.097C70.0439 135.649 69.8945 136.263 69.8943 136.885V168.137L63.3688 165.836V147.173C63.3688 146.657 63.267 146.147 63.069 145.671C62.8711 145.196 62.5811 144.764 62.2156 144.401C61.8501 144.037 61.4164 143.75 60.9395 143.555C60.4625 143.36 59.9517 143.261 59.4365 143.265H58.706C57.6717 143.268 56.6808 143.681 55.9505 144.413C55.2203 145.146 54.8102 146.138 54.8102 147.173V162.792L54.0676 162.525L53.7145 162.671C50.1792 164.072 47.1461 166.503 45.0081 169.649C42.87 172.794 41.7255 176.508 41.7227 180.311V326.015H453.755V158.178L439.839 164.485Z",
    fill: "#E5E9EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.642 216.165V175.125H353.718V203.991H326.63V177.889H317.353L293.333 136.276L269.301 177.889H260.024V195.055H237.014V177.889H220.384V149.425H190.958V164.18H170.408V177.889V216.165H151.988L104.361 227.792V302.494L461.73 303.468V216.165H384.642Z",
    fill: "#ADE0EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.03 222.812H151.514V226.319H156.03V222.812Z",
    fill: "#A3D1DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.03 227.706H151.514V231.212H156.03V227.706Z",
    fill: "#A3D1DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.03 232.601H151.514V236.107H156.03V232.601Z",
    fill: "#A3D1DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.03 237.494H151.514V241H156.03V237.494Z",
    fill: "#A3D1DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.091 222.812H157.574V226.319H162.091V222.812Z",
    fill: "#A3D1DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.091 227.706H157.574V231.212H162.091V227.706Z",
    fill: "#A3D1DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.091 232.601H157.574V236.107H162.091V232.601Z",
    fill: "#A3D1DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.091 237.494H157.574V241H162.091V237.494Z",
    fill: "#A3D1DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.253 222.812H163.736V226.319H168.253V222.812Z",
    fill: "#A3D1DB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M168.253 227.706H163.736V231.212H168.253V227.706Z",
    fill: "#A3D1DB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.253 232.601H163.736V236.107H168.253V232.601Z",
    fill: "#A3D1DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.253 237.494H163.736V241H168.253V237.494Z",
    fill: "#A3D1DB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M393.151 245.627H388.635V249.133H393.151V245.627Z",
    fill: "#A3D1DB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M393.151 250.509H388.635V254.015H393.151V250.509Z",
    fill: "#A3D1DB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M393.151 255.402H388.635V258.909H393.151V255.402Z",
    fill: "#A3D1DB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M393.151 260.297H388.635V263.803H393.151V260.297Z",
    fill: "#A3D1DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M399.2 245.627H394.684V249.133H399.2V245.627Z",
    fill: "#A3D1DB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M399.2 250.509H394.684V254.015H399.2V250.509Z",
    fill: "#A3D1DB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M399.2 255.402H394.684V258.909H399.2V255.402Z",
    fill: "#A3D1DB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M399.2 260.297H394.684V263.803H399.2V260.297Z",
    fill: "#A3D1DB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M405.374 245.627H400.857V249.133H405.374V245.627Z",
    fill: "#A3D1DB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M405.374 250.509H400.857V254.015H405.374V250.509Z",
    fill: "#A3D1DB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M405.374 255.402H400.857V258.909H405.374V255.402Z",
    fill: "#A3D1DB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M405.374 260.297H400.857V263.803H405.374V260.297Z",
    fill: "#A3D1DB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M335.64 210.54H331.123V214.046H335.64V210.54Z",
    fill: "#A3D1DB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M335.64 215.434H331.123V218.94H335.64V215.434Z",
    fill: "#A3D1DB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M335.64 220.328H331.123V223.834H335.64V220.328Z",
    fill: "#A3D1DB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M335.64 225.222H331.123V228.728H335.64V225.222Z",
    fill: "#A3D1DB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M341.691 210.54H337.174V214.046H341.691V210.54Z",
    fill: "#A3D1DB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M341.691 215.434H337.174V218.94H341.691V215.434Z",
    fill: "#A3D1DB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M341.691 220.328H337.174V223.834H341.691V220.328Z",
    fill: "#A3D1DB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M341.691 225.222H337.174V228.728H341.691V225.222Z",
    fill: "#A3D1DB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M347.849 210.54H343.332V214.046H347.849V210.54Z",
    fill: "#A3D1DB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M347.849 215.434H343.332V218.94H347.849V215.434Z",
    fill: "#A3D1DB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M347.849 220.328H343.332V223.834H347.849V220.328Z",
    fill: "#A3D1DB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M347.849 225.222H343.332V228.728H347.849V225.222Z",
    fill: "#A3D1DB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M156.03 246.309H151.514V249.815H156.03V246.309Z",
    fill: "#A3D1DB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M156.03 251.203H151.514V254.709H156.03V251.203Z",
    fill: "#A3D1DB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M156.03 256.097H151.514V259.603H156.03V256.097Z",
    fill: "#A3D1DB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M156.03 260.99H151.514V264.496H156.03V260.99Z",
    fill: "#A3D1DB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M162.091 246.309H157.574V249.815H162.091V246.309Z",
    fill: "#A3D1DB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.091 251.203H157.574V254.709H162.091V251.203Z",
    fill: "#A3D1DB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M162.091 256.097H157.574V259.603H162.091V256.097Z",
    fill: "#A3D1DB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M162.091 260.99H157.574V264.496H162.091V260.99Z",
    fill: "#A3D1DB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M168.253 246.309H163.736V249.815H168.253V246.309Z",
    fill: "#A3D1DB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M168.253 251.203H163.736V254.709H168.253V251.203Z",
    fill: "#A3D1DB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M168.253 256.097H163.736V259.603H168.253V256.097Z",
    fill: "#A3D1DB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M168.253 260.99H163.736V264.496H168.253V260.99Z",
    fill: "#A3D1DB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M133.944 246.309H129.428V249.815H133.944V246.309Z",
    fill: "#A3D1DB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M133.944 251.203H129.428V254.709H133.944V251.203Z",
    fill: "#A3D1DB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M133.944 256.097H129.428V259.603H133.944V256.097Z",
    fill: "#A3D1DB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M133.944 260.99H129.428V264.496H133.944V260.99Z",
    fill: "#A3D1DB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M139.997 246.309H135.48V249.815H139.997V246.309Z",
    fill: "#A3D1DB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M139.997 251.203H135.48V254.709H139.997V251.203Z",
    fill: "#A3D1DB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M139.997 256.097H135.48V259.603H139.997V256.097Z",
    fill: "#A3D1DB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M139.997 260.99H135.48V264.496H139.997V260.99Z",
    fill: "#A3D1DB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M146.155 246.309H141.639V249.815H146.155V246.309Z",
    fill: "#A3D1DB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M146.155 251.203H141.639V254.709H146.155V251.203Z",
    fill: "#A3D1DB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M146.155 256.097H141.639V259.603H146.155V256.097Z",
    fill: "#A3D1DB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M146.155 260.99H141.639V264.496H146.155V260.99Z",
    fill: "#A3D1DB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M111.849 246.309H107.332V249.815H111.849V246.309Z",
    fill: "#A3D1DB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M111.849 251.203H107.332V254.709H111.849V251.203Z",
    fill: "#A3D1DB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M111.849 256.097H107.332V259.603H111.849V256.097Z",
    fill: "#A3D1DB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M111.849 260.99H107.332V264.496H111.849V260.99Z",
    fill: "#A3D1DB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M117.9 246.309H113.383V249.815H117.9V246.309Z",
    fill: "#A3D1DB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M117.9 251.203H113.383V254.709H117.9V251.203Z",
    fill: "#A3D1DB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M117.9 256.097H113.383V259.603H117.9V256.097Z",
    fill: "#A3D1DB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M117.9 260.99H113.383V264.496H117.9V260.99Z",
    fill: "#A3D1DB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M124.073 246.309H119.557V249.815H124.073V246.309Z",
    fill: "#A3D1DB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M124.073 251.203H119.557V254.709H124.073V251.203Z",
    fill: "#A3D1DB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M124.073 256.097H119.557V259.603H124.073V256.097Z",
    fill: "#A3D1DB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M124.073 260.99H119.557V264.496H124.073V260.99Z",
    fill: "#A3D1DB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M270.081 184.499H264.066V188.943H270.081V184.499Z",
    fill: "#A3D1DB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M277.895 184.499H271.881V188.943H277.895V184.499Z",
    fill: "#A3D1DB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7 184.499H279.686V188.943H285.7V184.499Z",
    fill: "#A3D1DB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M293.516 184.499H287.502V188.943H293.516V184.499Z",
    fill: "#A3D1DB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M270.081 191.013H264.066V195.456H270.081V191.013Z",
    fill: "#A3D1DB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M277.895 191.013H271.881V195.456H277.895V191.013Z",
    fill: "#A3D1DB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7 191.013H279.686V195.456H285.7V191.013Z",
    fill: "#A3D1DB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M293.516 191.013H287.502V195.456H293.516V191.013Z",
    fill: "#A3D1DB"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M270.081 197.514H264.066V201.957H270.081V197.514Z",
    fill: "#A3D1DB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M277.895 197.514H271.881V201.957H277.895V197.514Z",
    fill: "#A3D1DB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7 197.514H279.686V201.957H285.7V197.514Z",
    fill: "#A3D1DB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M293.516 197.514H287.502V201.957H293.516V197.514Z",
    fill: "#A3D1DB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M270.081 204.027H264.066V208.471H270.081V204.027Z",
    fill: "#A3D1DB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M277.895 204.027H271.881V208.471H277.895V204.027Z",
    fill: "#A3D1DB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7 204.027H279.686V208.471H285.7V204.027Z",
    fill: "#A3D1DB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M293.516 204.027H287.502V208.471H293.516V204.027Z",
    fill: "#A3D1DB"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M270.081 210.54H264.066V214.984H270.081V210.54Z",
    fill: "#A3D1DB"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M277.895 210.54H271.881V214.984H277.895V210.54Z",
    fill: "#A3D1DB"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7 210.54H279.686V214.984H285.7V210.54Z",
    fill: "#A3D1DB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M293.516 210.54H287.502V214.984H293.516V210.54Z",
    fill: "#A3D1DB"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M270.081 217.053H264.066V221.496H270.081V217.053Z",
    fill: "#A3D1DB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M277.895 217.053H271.881V221.496H277.895V217.053Z",
    fill: "#A3D1DB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7 217.053H279.686V221.496H285.7V217.053Z",
    fill: "#A3D1DB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M293.516 217.053H287.502V221.496H293.516V217.053Z",
    fill: "#A3D1DB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M270.081 223.567H264.066V228.011H270.081V223.567Z",
    fill: "#A3D1DB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M277.895 223.567H271.881V228.011H277.895V223.567Z",
    fill: "#A3D1DB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7 223.567H279.686V228.011H285.7V223.567Z",
    fill: "#A3D1DB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M293.516 223.567H287.502V228.011H293.516V223.567Z",
    fill: "#A3D1DB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M193.442 282.93H194.793L194.793 149.425H193.442L193.442 282.93Z",
    fill: "#A3D1DB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M196.789 282.93H198.141L198.141 149.425H196.789L196.789 282.93Z",
    fill: "#A3D1DB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M200.125 282.93H201.477L201.477 149.425H200.125L200.125 282.93Z",
    fill: "#A3D1DB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M203.461 282.93H204.812L204.812 149.425H203.461L203.461 282.93Z",
    fill: "#A3D1DB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 154.294H208.539V158.117H216.075V154.294Z",
    fill: "#A3D1DB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 159.955H208.539V163.778H216.075V159.955Z",
    fill: "#A3D1DB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 165.604H208.539V169.427H216.075V165.604Z",
    fill: "#A3D1DB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 171.253H208.539V175.076H216.075V171.253Z",
    fill: "#A3D1DB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 176.902H208.539V180.725H216.075V176.902Z",
    fill: "#A3D1DB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 182.551H208.539V186.374H216.075V182.551Z",
    fill: "#A3D1DB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 188.2H208.539V192.023H216.075V188.2Z",
    fill: "#A3D1DB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 193.849H208.539V197.671H216.075V193.849Z",
    fill: "#A3D1DB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 199.51H208.539V203.333H216.075V199.51Z",
    fill: "#A3D1DB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 205.159H208.539V208.982H216.075V205.159Z",
    fill: "#A3D1DB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 210.808H208.539V214.63H216.075V210.808Z",
    fill: "#A3D1DB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M216.075 216.457H208.539V220.28H216.075V216.457Z",
    fill: "#A3D1DB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 173.834H175.75V177.657H183.286V173.834Z",
    fill: "#A3D1DB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 168.16H175.75V171.983H183.286V168.16Z",
    fill: "#A3D1DB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 179.483H175.75V183.306H183.286V179.483Z",
    fill: "#A3D1DB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 185.144H175.75V188.966H183.286V185.144Z",
    fill: "#A3D1DB"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 190.794H175.75V194.617H183.286V190.794Z",
    fill: "#A3D1DB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 196.442H175.75V200.265H183.286V196.442Z",
    fill: "#A3D1DB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 202.091H175.75V205.914H183.286V202.091Z",
    fill: "#A3D1DB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 207.74H175.75V211.563H183.286V207.74Z",
    fill: "#A3D1DB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 213.389H175.75V217.211H183.286V213.389Z",
    fill: "#A3D1DB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 219.037H175.75V222.86H183.286V219.037Z",
    fill: "#A3D1DB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 224.699H175.75V228.522H183.286V224.699Z",
    fill: "#A3D1DB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 230.348H175.75V234.17H183.286V230.348Z",
    fill: "#A3D1DB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M183.286 235.997H175.75V239.82H183.286V235.997Z",
    fill: "#A3D1DB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 181.711H226.373V185.534H232.619V181.711Z",
    fill: "#A3D1DB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 187.36H226.373V191.183H232.619V187.36Z",
    fill: "#A3D1DB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 193.009H226.373V196.832H232.619V193.009Z",
    fill: "#A3D1DB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 198.658H226.373V202.481H232.619V198.658Z",
    fill: "#A3D1DB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 204.318H226.373V208.141H232.619V204.318Z",
    fill: "#A3D1DB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 209.969H226.373V213.792H232.619V209.969Z",
    fill: "#A3D1DB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 215.617H226.373V219.44H232.619V215.617Z",
    fill: "#A3D1DB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 221.266H226.373V225.088H232.619V221.266Z",
    fill: "#A3D1DB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 226.915H226.373V230.738H232.619V226.915Z",
    fill: "#A3D1DB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M232.619 232.563H226.373V236.386H232.619V232.563Z",
    fill: "#A3D1DB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M454.632 223.312H388.635V226.148H454.632V223.312Z",
    fill: "#A3D1DB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M454.632 228.119H388.635V230.956H454.632V228.119Z",
    fill: "#A3D1DB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M454.632 232.929H388.635V235.765H454.632V232.929Z",
    fill: "#A3D1DB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M454.632 237.737H388.635V240.574H454.632V237.737Z",
    fill: "#A3D1DB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M373.125 181.139H370.35V278.644H373.125V181.139Z",
    fill: "#A3D1DB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M377.508 181.139H374.732V278.644H377.508V181.139Z",
    fill: "#A3D1DB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M381.889 181.139H379.113V278.644H381.889V181.139Z",
    fill: "#A3D1DB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M359.891 181.139H357.115V278.644H359.891V181.139Z",
    fill: "#A3D1DB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M364.272 181.139H361.496V278.644H364.272V181.139Z",
    fill: "#A3D1DB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M368.657 181.139H365.881V278.644H368.657V181.139Z",
    fill: "#A3D1DB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M403.803 348.184H147.762C139.048 348.184 131.984 355.248 131.984 363.962V371.339C131.984 380.053 139.048 387.117 147.762 387.117H403.803C412.517 387.117 419.581 380.053 419.581 371.339V363.962C419.581 355.248 412.517 348.184 403.803 348.184Z",
    fill: "#3F4551"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M510.074 400.571C510.074 398.493 509.665 396.434 508.869 394.514C508.074 392.594 506.908 390.849 505.439 389.38C503.969 387.91 502.224 386.744 500.304 385.949C498.384 385.154 496.326 384.744 494.247 384.744H17.3619C13.1644 384.744 9.13881 386.412 6.17072 389.38C3.20262 392.348 1.53516 396.373 1.53516 400.571C1.53516 404.768 3.20262 408.794 6.17072 411.762C9.13881 414.73 13.1644 416.398 17.3619 416.398H111.41C115.607 416.398 119.633 418.065 122.601 421.033C125.569 424.001 127.236 428.027 127.236 432.225C127.236 436.422 125.569 440.448 122.601 443.416C119.633 446.384 115.607 448.051 111.41 448.051H76.5541C72.3566 448.051 68.331 449.719 65.3629 452.687C62.3948 455.655 60.7273 459.681 60.7273 463.878C60.7273 468.076 62.3948 472.101 65.3629 475.069C68.331 478.037 72.3566 479.705 76.5541 479.705H386.053C390.251 479.705 394.276 478.037 397.244 475.069C400.212 472.101 401.88 468.076 401.88 463.878C401.88 459.681 400.212 455.655 397.244 452.687C394.276 449.719 390.251 448.051 386.053 448.051H366.793C362.596 448.051 358.57 446.384 355.602 443.416C352.634 440.448 350.966 436.422 350.966 432.225C350.966 428.027 352.634 424.001 355.602 421.033C358.57 418.065 362.596 416.398 366.793 416.398H494.296C498.485 416.385 502.498 414.712 505.456 411.745C508.413 408.778 510.074 404.76 510.074 400.571Z",
    fill: "#3F4551"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M182.825 385.597H16.8268C12.6293 385.597 8.60366 383.929 5.63556 380.961C2.66746 377.993 1 373.968 1 369.77C1 365.573 2.66746 361.547 5.63556 358.579C8.60366 355.611 12.6293 353.943 16.8268 353.943H182.825C187.023 353.943 191.049 355.611 194.017 358.579C196.985 361.547 198.652 365.573 198.652 369.77C198.652 373.968 196.985 377.993 194.017 380.961C191.049 383.929 187.023 385.597 182.825 385.597Z",
    fill: "#086B86"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M495.174 385.597H352.526C348.328 385.597 344.303 383.929 341.335 380.961C338.367 377.993 336.699 373.968 336.699 369.77C336.699 365.573 338.367 361.547 341.335 358.579C344.303 355.611 348.328 353.943 352.526 353.943H495.174C497.252 353.943 499.311 354.353 501.231 355.148C503.151 355.943 504.896 357.109 506.365 358.579C507.835 360.049 509.001 361.793 509.796 363.713C510.592 365.634 511.001 367.692 511.001 369.77C511.001 371.849 510.592 373.907 509.796 375.827C509.001 377.747 507.835 379.492 506.365 380.961C504.896 382.431 503.151 383.597 501.231 384.392C499.311 385.188 497.252 385.597 495.174 385.597Z",
    fill: "#086B86"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M485.008 354.82H65.3912C61.1937 354.82 57.1681 353.152 54.2 350.184C51.2319 347.216 49.5645 343.19 49.5645 338.993C49.5645 334.795 51.2319 330.77 54.2 327.802C57.1681 324.833 61.1937 323.166 65.3912 323.166H485.008C489.206 323.166 493.231 324.833 496.199 327.802C499.167 330.77 500.835 334.795 500.835 338.993C500.835 343.19 499.167 347.216 496.199 350.184C493.231 353.152 489.206 354.82 485.008 354.82Z",
    fill: "#909AA4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M479.443 381.858C490.538 381.858 499.531 372.865 499.531 361.77C499.531 350.676 490.538 341.683 479.443 341.683C468.349 341.683 459.355 350.676 459.355 361.77C459.355 372.865 468.349 381.858 479.443 381.858Z",
    fill: "#3BAD9B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M479.455 341.683V381.858C484.783 381.858 489.892 379.742 493.659 375.975C497.427 372.208 499.543 367.098 499.543 361.77C499.543 356.443 497.427 351.333 493.659 347.566C489.892 343.799 484.783 341.683 479.455 341.683Z",
    fill: "#38C7B0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M450.139 299.767H38.4355V326.027H450.139V299.767Z",
    fill: "#F9EAD1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M460.841 124.016H436.321C433.712 124.016 431.21 122.979 429.366 121.135C427.521 119.29 426.484 116.788 426.484 114.179C426.484 111.57 427.521 109.068 429.366 107.223C431.21 105.378 433.712 104.342 436.321 104.342H460.841C462.132 104.342 463.41 104.596 464.603 105.091C465.796 105.585 466.88 106.31 467.792 107.224C468.705 108.137 469.428 109.222 469.921 110.415C470.414 111.609 470.667 112.888 470.665 114.179C470.667 115.47 470.414 116.749 469.921 117.942C469.428 119.136 468.705 120.22 467.792 121.134C466.88 122.047 465.796 122.772 464.603 123.267C463.41 123.761 462.132 124.016 460.841 124.016Z",
    fill: "#C0D1ED"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2387 69.4259H58.7193C57.4281 69.4259 56.1495 69.1713 54.9567 68.6768C53.7639 68.1823 52.6803 67.4576 51.7678 66.544C50.8554 65.6303 50.1319 64.5458 49.6389 63.3524C49.1459 62.159 48.8929 60.8801 48.8945 59.5889C48.8929 58.2977 49.1459 57.0188 49.6389 55.8254C50.1319 54.632 50.8554 53.5475 51.7678 52.6339C52.6803 51.7203 53.7639 50.9955 54.9567 50.501C56.1495 50.0065 57.4281 49.752 58.7193 49.752H83.2387C85.8476 49.752 88.3497 50.7883 90.1944 52.6331C92.0392 54.4779 93.0756 56.98 93.0756 59.5889C93.0756 62.1978 92.0392 64.6999 90.1944 66.5447C88.3497 68.3895 85.8476 69.4259 83.2387 69.4259Z",
    fill: "#C0D1ED"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M442.859 176.816V319.464H378.895V208.214L384.714 205.366L389.778 202.882L397.156 199.254L402.233 196.758L409.611 193.142L414.687 190.647L422.455 186.836L427.519 184.352L434.897 180.724L439.962 178.241L442.859 176.816Z",
    fill: "#C0D1ED"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M414.688 190.647V319.465H409.611V193.143L414.688 190.647Z",
    fill: "#A6B7CC"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M427.52 184.354V319.466H422.455V186.837L427.52 184.354Z",
    fill: "#A6B7CC"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M439.963 178.241V319.465H434.898V180.725L439.963 178.241Z",
    fill: "#A6B7CC"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M389.779 202.883V319.465H384.715V205.366L389.779 202.883Z",
    fill: "#A6B7CC"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M402.233 196.758V319.464H397.156V199.254L402.233 196.758Z",
    fill: "#A6B7CC"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M387.649 319.465V203.93L384.715 205.366V319.465H387.649Z",
    fill: "#8A97AA"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M400.09 319.465V197.817L397.156 199.254V319.465H400.09Z",
    fill: "#8A97AA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M412.545 319.466V191.707L409.611 193.144V319.466H412.545Z",
    fill: "#8A97AA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M424.987 319.465V185.595L422.053 187.031V319.465H424.987Z",
    fill: "#8A97AA"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M437.43 319.465V179.483L434.496 180.92V319.465H437.43Z",
    fill: "#8A97AA"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M466.198 306.769C468.607 291.814 458.435 277.737 443.479 275.328C428.523 272.919 414.446 283.09 412.038 298.046C409.629 313.002 419.8 327.079 434.756 329.488C449.712 331.897 463.789 321.725 466.198 306.769Z",
    fill: "#A0A025"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M439.121 274.992V329.777C442.837 329.969 446.554 329.402 450.044 328.112C453.535 326.823 456.726 324.836 459.424 322.273C462.123 319.711 464.271 316.626 465.74 313.207C467.208 309.788 467.965 306.105 467.965 302.384C467.965 298.663 467.208 294.981 465.74 291.561C464.271 288.142 462.123 285.057 459.424 282.495C456.726 279.932 453.535 277.946 450.044 276.656C446.554 275.366 442.837 274.8 439.121 274.992Z",
    fill: "#C6C453"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M458.759 302.42C458.759 307.612 456.696 312.591 453.025 316.263C449.353 319.934 444.374 321.996 439.182 321.996C433.99 321.996 429.011 319.934 425.339 316.263C421.668 312.591 419.605 307.612 419.605 302.42",
    stroke: "#534741",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M450.141 302.42C450.141 305.342 448.98 308.144 446.914 310.211C444.848 312.277 442.045 313.438 439.123 313.438C436.201 313.438 433.399 312.277 431.333 310.211C429.266 308.144 428.105 305.342 428.105 302.42",
    stroke: "#534741",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M439.121 293.338V360.31",
    stroke: "#534741",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M429.076 381.858C440.17 381.858 449.164 372.865 449.164 361.77C449.164 350.676 440.17 341.683 429.076 341.683C417.982 341.683 408.988 350.676 408.988 361.77C408.988 372.865 417.982 381.858 429.076 381.858Z",
    fill: "#A0A025"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M429.076 341.683V381.858C434.404 381.858 439.513 379.742 443.28 375.975C447.048 372.208 449.164 367.098 449.164 361.77C449.164 356.443 447.048 351.333 443.28 347.566C439.513 343.799 434.404 341.683 429.076 341.683Z",
    fill: "#C6C453"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M381.744 356.913C375.241 356.913 369.004 359.496 364.406 364.095C359.808 368.693 357.225 374.93 357.225 381.432H406.251C406.251 374.932 403.67 368.697 399.074 364.099C394.478 359.501 388.245 356.916 381.744 356.913Z",
    fill: "#A0A025"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M408.734 367.968C405.163 367.968 401.738 369.386 399.213 371.912C396.688 374.437 395.27 377.862 395.27 381.433H422.236C422.236 379.661 421.886 377.908 421.207 376.271C420.529 374.635 419.533 373.149 418.279 371.899C417.025 370.648 415.536 369.657 413.899 368.982C412.261 368.308 410.506 367.963 408.734 367.968Z",
    fill: "#C6C453"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M347.996 207.423H287.525V237.664H347.996V207.423Z",
    fill: "#C6BDAF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M367.913 228.363H235.783V319.647H367.913V228.363Z",
    fill: "#F9EAD1"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M373.004 237.665H230.551V258.788H373.004V237.665Z",
    fill: "#E2D6C3"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M367.914 258.787H235.639V262.646H367.914V258.787Z",
    fill: "#C6BDAF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M367.914 289.601H235.639V293.46H367.914V289.601Z",
    fill: "#C6BDAF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M373.004 268.479H230.551V289.601H373.004V268.479Z",
    fill: "#E2D6C3"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M373.004 299.292H230.551V320.415H373.004V299.292Z",
    fill: "#E2D6C3"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M347.996 227.194H287.525V228.363H347.996V227.194Z",
    fill: "#968A7A"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M347.996 211.879H287.525V219.634H347.996V211.879Z",
    fill: "#968A7A"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M254.387 241.829H245.865V254.624H254.387V241.829Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M252.525 243.483H247.74V252.967H252.525V243.483Z",
    fill: "#968A7A"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M252.525 244.385L247.74 249.157V251.762L252.525 246.99V244.385Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M268.885 241.829H260.363V254.624H268.885V241.829Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M267.025 243.483H262.24V252.967H267.025V243.483Z",
    fill: "#968A7A"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M267.013 244.385L262.24 249.157V251.762L267.013 246.99V244.385Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M283.374 241.829H274.852V254.624H283.374V241.829Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M281.513 243.483H276.729V252.967H281.513V243.483Z",
    fill: "#968A7A"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M281.513 244.385L276.729 249.157V251.762L281.513 246.99V244.385Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M297.874 241.829H289.352V254.624H297.874V241.829Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M296.011 243.483H291.227V252.967H296.011V243.483Z",
    fill: "#968A7A"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M295.999 244.385L291.227 249.157V251.762L295.999 246.99V244.385Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M312.362 241.829H303.84V254.624H312.362V241.829Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M310.497 243.483H305.713V252.967H310.497V243.483Z",
    fill: "#968A7A"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M310.497 244.385L305.713 249.157V251.762L310.497 246.99V244.385Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M326.862 241.829H318.34V254.624H326.862V241.829Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M324.997 243.483H320.213V252.967H324.997V243.483Z",
    fill: "#968A7A"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M324.997 244.385L320.213 249.157V251.762L324.997 246.99V244.385Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M341.35 241.829H332.828V254.624H341.35V241.829Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M339.486 243.483H334.701V252.967H339.486V243.483Z",
    fill: "#968A7A"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M339.486 244.385L334.701 249.157V251.762L339.486 246.99V244.385Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M355.85 241.829H347.328V254.624H355.85V241.829Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M353.986 243.483H349.201V252.967H353.986V243.483Z",
    fill: "#968A7A"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M353.986 244.385L349.201 249.157V251.762L353.986 246.99V244.385Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M254.387 272.642H245.865V285.437H254.387V272.642Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M252.525 274.298H247.74V283.782H252.525V274.298Z",
    fill: "#968A7A"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M252.525 275.199L247.74 279.984V282.577L252.525 277.805V275.199Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M268.885 272.642H260.363V285.437H268.885V272.642Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M267.025 274.298H262.24V283.782H267.025V274.298Z",
    fill: "#968A7A"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M267.013 275.199L262.24 279.984V282.577L267.013 277.805V275.199Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M283.374 272.642H274.852V285.437H283.374V272.642Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M281.513 274.298H276.729V283.782H281.513V274.298Z",
    fill: "#968A7A"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M281.513 275.199L276.729 279.984V282.577L281.513 277.805V275.199Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M297.874 272.642H289.352V285.437H297.874V272.642Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M296.011 274.298H291.227V283.782H296.011V274.298Z",
    fill: "#968A7A"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M295.999 275.199L291.227 279.984V282.577L295.999 277.805V275.199Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M312.362 272.642H303.84V285.437H312.362V272.642Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M310.497 274.298H305.713V283.782H310.497V274.298Z",
    fill: "#968A7A"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M310.497 275.199L305.713 279.984V282.577L310.497 277.805V275.199Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M326.862 272.642H318.34V285.437H326.862V272.642Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M324.997 274.298H320.213V283.782H324.997V274.298Z",
    fill: "#968A7A"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M324.997 275.199L320.213 279.984V282.577L324.997 277.805V275.199Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M341.35 272.642H332.828V285.437H341.35V272.642Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M339.486 274.298H334.701V283.782H339.486V274.298Z",
    fill: "#968A7A"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M339.486 275.199L334.701 279.984V282.577L339.486 277.805V275.199Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M355.85 272.642H347.328V285.437H355.85V272.642Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M353.986 274.298H349.201V283.782H353.986V274.298Z",
    fill: "#968A7A"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M353.986 275.199L349.201 279.984V282.577L353.986 277.805V275.199Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M254.387 303.468H245.865V316.263H254.387V303.468Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M252.525 305.111H247.74V314.595H252.525V305.111Z",
    fill: "#968A7A"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M252.525 306.012L247.74 310.796V313.402L252.525 308.617V306.012Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M268.885 303.468H260.363V316.263H268.885V303.468Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M267.025 305.111H262.24V314.595H267.025V305.111Z",
    fill: "#968A7A"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M267.013 306.012L262.24 310.796V313.402L267.013 308.617V306.012Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M283.374 303.468H274.852V316.263H283.374V303.468Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M281.513 305.111H276.729V314.595H281.513V305.111Z",
    fill: "#968A7A"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M281.513 306.012L276.729 310.796V313.402L281.513 308.617V306.012Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M297.874 303.468H289.352V316.263H297.874V303.468Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M296.011 305.111H291.227V314.595H296.011V305.111Z",
    fill: "#968A7A"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M295.999 306.012L291.227 310.796V313.402L295.999 308.617V306.012Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M312.362 303.468H303.84V316.263H312.362V303.468Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M310.497 305.111H305.713V314.595H310.497V305.111Z",
    fill: "#968A7A"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M310.497 306.012L305.713 310.796V313.402L310.497 308.617V306.012Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M326.862 303.468H318.34V316.263H326.862V303.468Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M324.997 305.111H320.213V314.595H324.997V305.111Z",
    fill: "#968A7A"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M324.997 306.012L320.213 310.796V313.402L324.997 308.617V306.012Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M341.35 303.468H332.828V316.263H341.35V303.468Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M339.486 305.111H334.701V314.595H339.486V305.111Z",
    fill: "#968A7A"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M339.486 306.012L334.701 310.796V313.402L339.486 308.617V306.012Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M355.85 303.468H347.328V316.263H355.85V303.468Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M353.986 305.111H349.201V314.595H353.986V305.111Z",
    fill: "#968A7A"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M353.986 306.012L349.201 310.796V313.402L353.986 308.617V306.012Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M224.791 275.661H29.5371V320.378H224.791V275.661Z",
    fill: "#C6BDAF"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M224.791 270.646H29.5371V275.661H224.791V270.646Z",
    fill: "#909AA4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M134.846 286.594H120.078V320.378H134.846V286.594Z",
    fill: "#968A7A"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M163.869 289.065L152.06 309.713H143.781V305.343L153.095 289.065H163.869Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M174.938 289.065L163.104 309.713H156.092L167.901 289.065H174.938Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 286.594H138.354V312.184H176.91V286.594Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 312.185H138.354V314.084H176.91V312.185Z",
    fill: "#5E6675"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M174.183 289.077H141.068V309.713H174.183V289.077Z",
    fill: "#9DC7C2"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M161.156 289.065L149.335 309.713H141.068V305.343L150.37 289.065H161.156Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M172.209 289.065L160.375 309.713H153.375L165.184 289.065H172.209Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M220.578 286.594H182.021V312.184H220.578V286.594Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M220.578 312.185H182.021V314.084H220.578V312.185Z",
    fill: "#5E6675"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M217.851 289.077H184.736V309.713H217.851V289.077Z",
    fill: "#9DC7C2"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M204.824 289.065L193.015 309.713H184.736V305.343L194.038 289.065H204.824Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M215.879 289.065L204.057 309.713H197.045L208.854 289.065H215.879Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9159 286.594H34.3594V312.184H72.9159V286.594Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9159 312.185H34.3594V314.084H72.9159V312.185Z",
    fill: "#5E6675"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1887 289.077H37.0742V309.713H70.1887V289.077Z",
    fill: "#9DC7C2"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M57.1621 289.065L45.3407 309.713H37.0742V305.343L46.3755 289.065H57.1621Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M68.2152 289.065L56.3816 309.713H49.3691L61.1905 289.065H68.2152Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M116.584 286.594H78.0273V312.184H116.584V286.594Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M116.584 312.185H78.0273V314.084H116.584V312.185Z",
    fill: "#5E6675"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M113.857 289.077H80.7422V309.713H113.857V289.077Z",
    fill: "#9DC7C2"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M100.83 289.065L89.0086 309.713H80.7422V305.343L90.0435 289.065H100.83Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M111.885 289.065L100.051 309.713H93.0508L104.86 289.065H111.885Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0887 281.188C36.5546 281.188 37.9604 280.606 38.997 279.569C40.0335 278.533 40.6159 277.127 40.6159 275.661H29.5371C29.5371 276.389 29.6809 277.11 29.9602 277.782C30.2394 278.454 30.6488 279.065 31.1646 279.578C31.6804 280.092 32.2926 280.498 32.966 280.775C33.6394 281.051 34.3608 281.192 35.0887 281.188Z",
    fill: "#FECAB3"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7557 281.188C46.2227 281.188 47.6299 280.606 48.6683 279.57C49.7068 278.534 50.2919 277.128 50.2951 275.661H39.2285C39.2285 277.127 39.8108 278.533 40.8474 279.569C41.8839 280.606 43.2898 281.188 44.7557 281.188Z",
    fill: "#FECAB3"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4569 281.188C55.9228 281.188 57.3287 280.606 58.3652 279.569C59.4018 278.533 59.9841 277.127 59.9841 275.661H48.9297C48.9297 277.127 49.512 278.533 50.5486 279.569C51.5851 280.606 52.991 281.188 54.4569 281.188Z",
    fill: "#FECAB3"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1483 281.188C65.6142 281.188 67.0201 280.606 68.0566 279.569C69.0932 278.533 69.6755 277.127 69.6755 275.661H58.6211C58.6211 277.127 59.2034 278.533 60.24 279.569C61.2765 280.606 62.6824 281.188 64.1483 281.188Z",
    fill: "#FECAB3"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8377 281.188C75.3048 281.188 76.7119 280.606 77.7504 279.57C78.7889 278.534 79.3739 277.128 79.3771 275.661H68.3105C68.3105 277.127 68.8929 278.533 69.9294 279.569C70.966 280.606 72.3718 281.188 73.8377 281.188Z",
    fill: "#FECAB3"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5428 281.188C85.0087 281.188 86.4146 280.606 87.4511 279.569C88.4877 278.533 89.07 277.127 89.07 275.661H78.0156C78.0156 277.127 78.598 278.533 79.6345 279.569C80.6711 280.606 82.0769 281.188 83.5428 281.188Z",
    fill: "#FECAB3"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2342 281.188C94.7001 281.188 96.106 280.606 97.1426 279.569C98.1791 278.533 98.7614 277.127 98.7614 275.661H87.707C87.707 277.127 88.2894 278.533 89.3259 279.569C90.3625 280.606 91.7683 281.188 93.2342 281.188Z",
    fill: "#FECAB3"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M102.924 281.188C104.39 281.188 105.795 280.606 106.832 279.569C107.869 278.533 108.451 277.127 108.451 275.661H97.3965C97.3965 277.127 97.9788 278.533 99.0154 279.569C100.052 280.606 101.458 281.188 102.924 281.188Z",
    fill: "#FECAB3"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M112.629 281.188C114.095 281.188 115.501 280.606 116.538 279.569C117.574 278.533 118.156 277.127 118.156 275.661H107.09C107.093 277.128 107.678 278.534 108.717 279.57C109.755 280.606 111.162 281.188 112.629 281.188Z",
    fill: "#FECAB3"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M122.318 281.188C123.044 281.188 123.763 281.045 124.433 280.768C125.104 280.49 125.713 280.083 126.227 279.569C126.74 279.056 127.147 278.447 127.425 277.776C127.702 277.106 127.845 276.387 127.845 275.661H116.791C116.791 277.127 117.373 278.533 118.41 279.569C119.446 280.606 120.852 281.188 122.318 281.188Z",
    fill: "#FECAB3"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M132.01 281.188C133.476 281.188 134.881 280.606 135.918 279.569C136.954 278.533 137.537 277.127 137.537 275.661H126.482C126.482 277.127 127.065 278.533 128.101 279.569C129.138 280.606 130.544 281.188 132.01 281.188Z",
    fill: "#FECAB3"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M141.713 281.188C143.179 281.188 144.584 280.606 145.621 279.569C146.657 278.533 147.24 277.127 147.24 275.661H136.137C136.138 276.391 136.284 277.113 136.565 277.786C136.847 278.459 137.258 279.07 137.776 279.583C138.294 280.097 138.909 280.503 139.584 280.778C140.26 281.054 140.983 281.193 141.713 281.188Z",
    fill: "#FECAB3"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M151.404 281.188C152.87 281.188 154.276 280.606 155.312 279.569C156.349 278.533 156.931 277.127 156.931 275.661H145.877C145.877 276.387 146.02 277.106 146.298 277.776C146.575 278.447 146.983 279.056 147.496 279.569C148.009 280.083 148.618 280.49 149.289 280.768C149.96 281.045 150.678 281.188 151.404 281.188Z",
    fill: "#FECAB3"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M161.094 281.188C162.56 281.188 163.966 280.606 165.002 279.569C166.039 278.533 166.621 277.127 166.621 275.661H155.615C155.615 277.119 156.191 278.517 157.217 279.552C158.243 280.587 159.636 281.175 161.094 281.188Z",
    fill: "#FECAB3"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M170.797 281.188C172.263 281.188 173.669 280.606 174.706 279.569C175.742 278.533 176.324 277.127 176.324 275.661H165.258C165.261 277.128 165.846 278.534 166.885 279.57C167.923 280.606 169.33 281.188 170.797 281.188Z",
    fill: "#FECAB3"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M180.488 281.188C181.954 281.188 183.36 280.606 184.396 279.569C185.433 278.533 186.015 277.127 186.015 275.661H174.961C174.961 276.387 175.104 277.106 175.382 277.776C175.659 278.447 176.067 279.056 176.58 279.569C177.093 280.083 177.702 280.49 178.373 280.768C179.044 281.045 179.762 281.188 180.488 281.188Z",
    fill: "#FECAB3"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M190.178 281.188C191.643 281.188 193.049 280.606 194.086 279.569C195.122 278.533 195.705 277.127 195.705 275.661H184.65C184.65 277.127 185.233 278.533 186.269 279.569C187.306 280.606 188.712 281.188 190.178 281.188Z",
    fill: "#FECAB3"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M199.883 281.188C201.349 281.188 202.755 280.606 203.791 279.569C204.828 278.533 205.41 277.127 205.41 275.661H194.344C194.347 277.128 194.932 278.534 195.97 279.57C197.009 280.606 198.416 281.188 199.883 281.188Z",
    fill: "#FECAB3"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M209.572 281.188C211.038 281.188 212.444 280.606 213.48 279.569C214.517 278.533 215.099 277.127 215.099 275.661H204.045C204.045 277.127 204.627 278.533 205.664 279.569C206.7 280.606 208.106 281.188 209.572 281.188Z",
    fill: "#FECAB3"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M219.264 281.188C220.729 281.188 222.135 280.606 223.172 279.569C224.208 278.533 224.791 277.127 224.791 275.661H213.736C213.736 276.387 213.879 277.106 214.157 277.776C214.435 278.447 214.842 279.056 215.355 279.569C215.868 280.083 216.478 280.49 217.148 280.768C217.819 281.045 218.538 281.188 219.264 281.188Z",
    fill: "#FECAB3"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M111.07 291.439C112.662 288.743 113.341 285.605 113.006 282.491C112.789 278.617 111.043 274.987 108.15 272.4C105.257 269.813 101.455 268.481 97.5807 268.698C93.7061 268.914 90.0761 270.661 87.4893 273.553C84.9025 276.446 83.5708 280.248 83.7871 284.123C83.7825 286.659 84.4414 289.152 85.6985 291.354C86.2508 292.296 86.411 293.417 86.1445 294.476C85.8781 295.535 85.2064 296.447 84.2741 297.015C79.1405 300.109 75.1617 304.8 72.9463 310.369C70.7308 315.939 70.4008 322.081 72.0065 327.855C73.6122 333.63 77.0653 338.72 81.8377 342.347C86.6101 345.973 92.439 347.936 98.433 347.936C104.427 347.936 110.256 345.973 115.028 342.347C119.801 338.72 123.254 333.63 124.859 327.855C126.465 322.081 126.135 315.939 123.92 310.369C121.704 304.8 117.725 300.109 112.592 297.015C111.659 296.47 110.976 295.581 110.692 294.538C110.407 293.496 110.543 292.383 111.07 291.439Z",
    fill: "#A0A025"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M112.579 297.027C111.645 296.48 110.963 295.587 110.681 294.542C110.398 293.497 110.538 292.382 111.07 291.439C112.662 288.742 113.341 285.604 113.005 282.491C112.625 279.2 111.145 276.135 108.805 273.79C106.465 271.446 103.402 269.96 100.113 269.574C99.5628 269.515 99.0101 269.487 98.457 269.488V347.928C104.451 347.933 110.281 345.974 115.055 342.351C119.83 338.727 123.285 333.639 124.893 327.865C126.5 322.091 126.171 315.949 123.956 310.379C121.741 304.81 117.762 300.12 112.628 297.027H112.579Z",
    fill: "#C6C453"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M117.983 320.512C117.983 325.704 115.921 330.683 112.249 334.354C108.578 338.026 103.599 340.088 98.4066 340.088C93.2146 340.088 88.2352 338.026 84.5639 334.354C80.8926 330.683 78.8301 325.704 78.8301 320.512",
    stroke: "#534741",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M109.426 320.512C109.426 321.959 109.141 323.391 108.588 324.728C108.034 326.065 107.222 327.279 106.199 328.303C105.176 329.326 103.962 330.137 102.625 330.691C101.288 331.245 99.8554 331.53 98.4085 331.53C96.9616 331.53 95.5289 331.245 94.1921 330.691C92.8554 330.137 91.6408 329.326 90.6177 328.303C89.5946 327.279 88.783 326.065 88.2293 324.728C87.6756 323.391 87.3906 321.959 87.3906 320.512",
    stroke: "#534741",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4082 311.43V378.401",
    stroke: "#534741",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7539 307.606V377.573",
    stroke: "#534741",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6206 331.7C58.8813 330.903 58.4256 329.883 58.3244 328.8C58.2231 327.717 58.4819 326.631 59.0606 325.71C61.1477 322.488 62.0807 318.653 61.707 314.832C61.3333 311.011 59.675 307.43 57.0031 304.673C56.2631 303.901 55.7977 302.907 55.6789 301.844C55.5601 300.781 55.7944 299.709 56.3457 298.793C57.8196 296.303 58.4474 293.403 58.1353 290.526C57.9227 288.534 57.2676 286.614 56.2179 284.907C55.1682 283.2 53.7505 281.749 52.0682 280.66C50.386 279.571 48.4818 278.872 46.4947 278.613C44.5075 278.355 42.4878 278.543 40.5829 279.165C38.678 279.787 36.9361 280.827 35.4845 282.209C34.0329 283.59 32.9082 285.278 32.1927 287.15C31.4771 289.022 31.1887 291.03 31.3486 293.027C31.5085 295.025 32.1126 296.961 33.1168 298.695C33.6818 299.621 33.9292 300.705 33.8215 301.784C33.7139 302.863 33.257 303.877 32.5203 304.673C29.8514 307.429 28.194 311.007 27.8182 314.825C27.4424 318.642 28.3703 322.475 30.4506 325.698C31.0337 326.623 31.2938 327.715 31.1903 328.803C31.0868 329.891 30.6254 330.914 29.8784 331.712C27.2671 334.592 25.5478 338.168 24.9295 342.005C24.3111 345.843 24.8202 349.778 26.3949 353.332C27.9697 356.886 30.5423 359.906 33.8005 362.026C37.0587 364.146 40.8623 365.274 44.7495 365.274C48.6367 365.274 52.4403 364.146 55.6985 362.026C58.9567 359.906 61.5294 356.886 63.1041 353.332C64.6788 349.778 65.1879 345.843 64.5695 342.005C63.9512 338.168 62.232 334.592 59.6206 331.712V331.7Z",
    fill: "#3BAD9B"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6189 331.7C58.8796 330.902 58.4239 329.883 58.3227 328.8C58.2215 327.717 58.4802 326.631 59.0589 325.71C61.1461 322.488 62.079 318.653 61.7053 314.832C61.3316 311.011 59.6733 307.43 57.0014 304.673C56.2614 303.901 55.7961 302.907 55.6772 301.844C55.5584 300.781 55.7927 299.709 56.344 298.792C57.8179 296.303 58.4457 293.402 58.1336 290.526C57.7993 287.491 56.4459 284.659 54.2945 282.492C52.143 280.325 49.3206 278.951 46.2879 278.595C45.7787 278.537 45.2665 278.508 44.7539 278.51V365.216C48.6388 365.223 52.4418 364.1 55.7003 361.985C58.9587 359.87 61.532 356.853 63.1071 353.302C64.6821 349.75 65.1909 345.818 64.5716 341.983C63.9523 338.148 62.2316 334.575 59.6189 331.7Z",
    fill: "#38C7B0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M177.908 274.991V241.341",
    stroke: "#909AA4",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M184.759 256.012H171.173C170.422 256.012 169.703 255.715 169.171 255.185C168.639 254.656 168.339 253.937 168.336 253.187C168.336 252.435 168.635 251.713 169.167 251.181C169.699 250.649 170.42 250.351 171.173 250.351H184.759C185.512 250.351 186.233 250.649 186.765 251.181C187.297 251.713 187.596 252.435 187.596 253.187C187.596 253.559 187.522 253.927 187.38 254.271C187.237 254.614 187.028 254.926 186.764 255.189C186.501 255.451 186.188 255.659 185.844 255.8C185.5 255.941 185.131 256.013 184.759 256.012Z",
    stroke: "#909AA4",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M184.759 266.749H171.173C170.422 266.749 169.703 266.452 169.171 265.922C168.639 265.393 168.339 264.675 168.336 263.925C168.336 263.172 168.635 262.451 169.167 261.919C169.699 261.387 170.42 261.088 171.173 261.088H184.759C185.512 261.088 186.233 261.387 186.765 261.919C187.297 262.451 187.596 263.172 187.596 263.925C187.596 264.296 187.522 264.665 187.38 265.008C187.237 265.352 187.028 265.664 186.764 265.926C186.501 266.188 186.188 266.396 185.844 266.538C185.5 266.679 185.131 266.751 184.759 266.749Z",
    stroke: "#909AA4",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M207.807 274.298V259.53",
    stroke: "#909AA4",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M199.041 336.996C198.971 336.73 198.848 336.481 198.68 336.264C198.512 336.046 198.302 335.864 198.063 335.729C197.823 335.594 197.559 335.508 197.286 335.477C197.013 335.446 196.736 335.47 196.472 335.547L190.921 336.947C190.63 337.011 190.357 337.134 190.117 337.31C189.878 337.487 189.678 337.711 189.531 337.969C189.384 338.228 189.293 338.514 189.264 338.81C189.235 339.106 189.269 339.404 189.363 339.686L189.582 340.283C189.797 340.798 190.207 341.206 190.723 341.418C191.239 341.63 191.818 341.629 192.333 341.415L197.629 339.419C198.119 339.256 198.533 338.921 198.793 338.474C199.053 338.028 199.142 337.502 199.041 336.996Z",
    fill: "#FCB28D"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M191.542 339.309C184.708 339.083 178.221 336.243 173.419 331.376C168.617 326.508 165.866 319.983 165.732 313.146",
    stroke: "#FCB28D",
    strokeWidth: 3.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M175.472 329.399C171.162 325.055 168.694 319.215 168.582 313.097C168.559 312.343 168.242 311.627 167.698 311.103C167.154 310.58 166.427 310.29 165.672 310.297C164.917 310.315 164.2 310.63 163.675 311.174C163.414 311.442 163.209 311.761 163.074 312.11C162.938 312.459 162.873 312.832 162.884 313.207C163.024 320.275 165.693 327.058 170.406 332.327C175.118 337.596 181.564 341.002 188.572 341.926L189.449 336.289C184.147 335.63 179.223 333.203 175.472 329.399Z",
    fill: "#FF6C5C"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M152.463 400.389C159.768 389.81 172.648 371.536 161.046 352.97",
    stroke: "#B3B3B3",
    strokeWidth: 4.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M168.142 405.745V405.659C168.155 404.865 167.855 404.097 167.305 403.523C166.756 402.948 166.003 402.614 165.208 402.591C164.309 402.589 163.41 402.532 162.518 402.421C161.385 402.238 159.766 400.4 158.865 399.414C157.964 398.428 156.856 398.196 156.54 398.915C156.188 399.569 155.676 400.124 155.053 400.529C154.429 400.933 153.714 401.173 152.973 401.228C152.291 401.275 151.609 401.134 151.002 400.821C150.394 400.507 149.884 400.033 149.527 399.45C149.43 399.183 149.272 399.231 149.272 399.231C148.188 399.231 148.225 400.656 148.225 400.656V405.769L168.142 405.745Z",
    fill: "#297DB5"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M148.236 405.745V406.853C148.236 406.977 148.285 407.096 148.371 407.184C148.457 407.273 148.575 407.325 148.699 407.328H167.241C168.178 407.121 168.166 406.037 168.142 405.745H148.236Z",
    fill: "#02B3B2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M148.238 405.988H168.143C168.208 405.988 168.27 405.963 168.315 405.917C168.361 405.871 168.387 405.81 168.387 405.745C168.388 405.712 168.383 405.679 168.372 405.648C168.36 405.617 168.343 405.589 168.32 405.565C168.297 405.541 168.27 405.522 168.239 405.509C168.209 405.496 168.176 405.489 168.143 405.489H148.238C148.205 405.489 148.172 405.496 148.142 405.509C148.111 405.522 148.084 405.541 148.061 405.565C148.039 405.589 148.021 405.617 148.009 405.648C147.998 405.679 147.993 405.712 147.994 405.745C147.994 405.81 148.02 405.871 148.066 405.917C148.111 405.963 148.173 405.988 148.238 405.988Z",
    fill: "#96C9E0"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M168.849 368.723C168.842 362.541 167.064 356.491 163.723 351.289C163.277 350.58 162.568 350.076 161.752 349.887C160.936 349.698 160.078 349.838 159.365 350.279C159.011 350.499 158.704 350.786 158.461 351.125C158.219 351.464 158.046 351.848 157.952 352.254C157.858 352.66 157.845 353.081 157.914 353.492C157.983 353.903 158.133 354.296 158.354 354.649C161.07 358.841 162.516 363.728 162.518 368.723C162.367 374.442 160.879 380.046 158.172 385.085C156.268 388.825 154.108 392.43 151.707 395.872L158.245 397.503C160.308 394.414 162.182 391.202 163.857 387.886C166.986 381.972 168.695 375.411 168.849 368.723Z",
    fill: "#455E8F"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M116.329 387.752L112.482 399.61C112.366 399.967 112.396 400.355 112.564 400.69C112.733 401.025 113.027 401.28 113.383 401.399C113.694 401.5 114.03 401.489 114.334 401.369C114.638 401.249 114.891 401.028 115.05 400.742L121.759 388.896C121.861 388.714 121.921 388.512 121.936 388.304C121.95 388.096 121.919 387.887 121.843 387.693C121.767 387.498 121.65 387.323 121.498 387.18C121.347 387.036 121.165 386.928 120.967 386.863L119.19 386.291C118.617 386.107 117.994 386.157 117.458 386.431C116.921 386.704 116.516 387.18 116.329 387.752Z",
    fill: "#DD8262"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M119.639 388.725C124.222 388.322 128.682 387.021 132.762 384.894C136.843 382.768 140.465 379.859 143.421 376.333C146.378 372.807 148.61 368.733 149.992 364.344C151.374 359.955 151.878 355.337 151.475 350.753",
    stroke: "#B3B3B3",
    strokeWidth: 4.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M157.344 359.592C157.584 359.604 157.823 359.604 158.063 359.592C159.232 359.502 160.372 359.181 161.417 358.649C162.463 358.116 163.392 357.383 164.154 356.491C164.915 355.598 165.492 354.564 165.853 353.448C166.214 352.332 166.351 351.156 166.256 349.987C165.347 338.677 165.863 327.298 167.79 316.117C168.025 314.947 168.024 313.741 167.786 312.571C167.547 311.401 167.077 310.29 166.402 309.305C165.727 308.32 164.862 307.48 163.857 306.835C162.852 306.19 161.728 305.753 160.552 305.55C159.375 305.346 158.17 305.381 157.007 305.651C155.844 305.921 154.747 306.422 153.78 307.123C152.814 307.825 151.998 308.713 151.381 309.735C150.763 310.757 150.357 311.892 150.186 313.074C148.014 325.714 147.434 338.577 148.457 351.362C148.634 353.6 149.647 355.688 151.293 357.213C152.94 358.738 155.1 359.587 157.344 359.592Z",
    fill: "#395487"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M112.58 401.959H112.665C113.44 402.15 114.259 402.027 114.944 401.617C115.628 401.206 116.122 400.541 116.318 399.767C116.516 398.891 116.772 398.029 117.085 397.186C117.511 396.127 119.653 394.946 120.834 394.24C122.015 393.534 122.454 392.536 121.82 392.073C121.256 391.591 120.822 390.975 120.558 390.282C120.294 389.588 120.209 388.839 120.311 388.104C120.426 387.438 120.721 386.815 121.162 386.303C121.604 385.79 122.177 385.407 122.819 385.195C123.099 385.195 123.087 384.988 123.087 384.988C123.318 383.928 121.869 383.661 121.869 383.661L116.89 382.528L112.58 401.959Z",
    fill: "#297DB5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M116.949 382.529L116.669 382.468L115.865 382.286C115.744 382.263 115.62 382.287 115.516 382.352C115.412 382.418 115.337 382.52 115.305 382.639L111.227 400.73C111.227 401.692 112.286 401.947 112.578 401.947L116.949 382.529Z",
    fill: "#02B3B2"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M116.718 382.48L112.336 401.886C112.325 401.95 112.339 402.016 112.375 402.071C112.411 402.125 112.467 402.163 112.53 402.178C112.562 402.187 112.594 402.189 112.627 402.185C112.659 402.18 112.69 402.169 112.717 402.152C112.745 402.135 112.769 402.112 112.787 402.085C112.805 402.058 112.817 402.027 112.823 401.995L117.193 382.516C117.2 382.485 117.201 382.453 117.196 382.421C117.191 382.39 117.179 382.359 117.162 382.332C117.146 382.305 117.123 382.282 117.097 382.263C117.071 382.244 117.042 382.231 117.011 382.224C116.979 382.217 116.947 382.216 116.916 382.221C116.884 382.226 116.854 382.238 116.827 382.255C116.8 382.272 116.776 382.294 116.758 382.32C116.739 382.346 116.726 382.375 116.718 382.407",
    fill: "#96C9E0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M123.963 384.659C130.894 383.015 137.068 379.082 141.486 373.495C145.905 367.907 148.31 360.993 148.312 353.87C148.312 352.932 148.312 351.995 148.19 351.058C148.148 350.621 148.195 350.181 148.327 349.762C148.458 349.344 148.673 348.957 148.957 348.623C149.228 348.278 149.567 347.993 149.952 347.783C150.337 347.574 150.761 347.445 151.197 347.405H151.489C152.317 347.403 153.115 347.712 153.724 348.272C154.333 348.831 154.709 349.6 154.776 350.425C154.886 351.557 154.935 352.689 154.935 353.821C154.918 362.511 151.953 370.939 146.523 377.724C141.093 384.509 133.522 389.251 125.046 391.172L123.963 384.659Z",
    fill: "#395487"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M166.766 347.454H147.53C146.91 335.935 147.58 324.383 149.527 313.013C149.909 310.784 151.067 308.763 152.796 307.306C154.525 305.849 156.713 305.05 158.974 305.051C159.525 305.053 160.074 305.098 160.618 305.185C161.859 305.4 163.046 305.857 164.111 306.531C165.176 307.204 166.097 308.081 166.823 309.111C167.549 310.141 168.065 311.304 168.341 312.533C168.617 313.762 168.649 315.034 168.434 316.276C166.675 326.569 166.115 337.032 166.766 347.454Z",
    fill: "#FF8578"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M179.004 289.333C179.655 290.962 179.655 292.78 179.004 294.41C179.567 294.072 180.032 293.593 180.355 293.022C181.183 291.634 181.086 290.051 180.136 289.491C179.794 289.292 179.387 289.235 179.004 289.333Z",
    fill: "#2D2620"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M159.133 306.768L159.973 300.169C160.039 299.646 160.31 299.171 160.727 298.848C161.144 298.525 161.672 298.38 162.195 298.446C162.718 298.513 163.193 298.784 163.516 299.201C163.839 299.617 163.984 300.145 163.917 300.668L163.077 307.267C163.045 307.526 162.961 307.776 162.832 308.003C162.702 308.229 162.53 308.428 162.323 308.588C162.117 308.748 161.881 308.866 161.629 308.935C161.378 309.004 161.115 309.022 160.856 308.989C160.597 308.957 160.347 308.873 160.12 308.744C159.893 308.614 159.694 308.442 159.534 308.235C159.374 308.029 159.256 307.793 159.188 307.541C159.119 307.29 159.1 307.027 159.133 306.768Z",
    fill: "url(#paint0_linear_291_4339)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M162.227 305.171L163.7 306.024C164.548 306.524 165.486 306.853 166.461 306.991C167.436 307.128 168.429 307.072 169.382 306.826C170.335 306.579 171.231 306.147 172.017 305.554C172.803 304.961 173.464 304.219 173.963 303.37L179.113 294.616C179.97 293.16 180.215 291.422 179.793 289.786C179.37 288.149 178.316 286.747 176.861 285.887L172.782 283.452C172.062 283.026 171.265 282.747 170.437 282.629C169.609 282.512 168.766 282.559 167.956 282.768C167.146 282.978 166.386 283.345 165.718 283.849C165.05 284.352 164.489 284.983 164.065 285.704L159.268 293.849C158.718 294.787 158.358 295.823 158.209 296.9C158.06 297.977 158.125 299.072 158.399 300.124C158.674 301.176 159.154 302.163 159.81 303.029C160.467 303.895 161.288 304.623 162.227 305.171Z",
    fill: "#FCB28D"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M174.389 297.903C174.524 298.087 174.695 298.241 174.892 298.356C175.089 298.471 175.307 298.545 175.533 298.573",
    stroke: "#D8654E",
    strokeWidth: 0.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M168.143 294.228C168.277 294.414 168.452 294.568 168.654 294.678C168.851 294.798 169.071 294.877 169.299 294.909",
    stroke: "#D8654E",
    strokeWidth: 0.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M169.3 304.49C169.411 304.22 169.469 303.93 169.47 303.638C169.468 303.346 169.41 303.056 169.3 302.786C169.184 302.508 169.014 302.255 168.801 302.043C168.586 301.826 168.329 301.656 168.046 301.544C167.503 301.325 166.896 301.325 166.354 301.544",
    stroke: "#D8654E",
    strokeWidth: 0.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M175.096 297.672C175.212 297.739 175.35 297.757 175.48 297.723C175.61 297.689 175.721 297.605 175.79 297.49L176.374 296.503C176.44 296.389 176.458 296.253 176.424 296.125C176.39 295.997 176.306 295.888 176.192 295.822C176.136 295.787 176.074 295.763 176.009 295.753C175.944 295.743 175.878 295.746 175.814 295.762C175.751 295.778 175.691 295.806 175.639 295.846C175.586 295.885 175.542 295.935 175.51 295.992L174.925 296.99C174.858 297.104 174.838 297.239 174.87 297.366C174.902 297.494 174.983 297.604 175.096 297.672Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M169.007 294.081C169.12 294.148 169.256 294.168 169.383 294.136C169.511 294.104 169.621 294.023 169.689 293.911L170.273 292.912C170.34 292.798 170.358 292.662 170.323 292.534C170.289 292.406 170.205 292.297 170.091 292.231C170.034 292.196 169.972 292.174 169.906 292.164C169.841 292.155 169.775 292.159 169.711 292.176C169.647 292.193 169.587 292.223 169.535 292.264C169.484 292.304 169.441 292.355 169.409 292.413L168.825 293.399C168.758 293.514 168.741 293.65 168.775 293.778C168.809 293.906 168.893 294.015 169.007 294.081Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M170.506 300.242C170.545 300.298 170.6 300.34 170.664 300.363C171.17 300.525 171.718 300.489 172.199 300.263C172.68 300.038 173.058 299.639 173.257 299.146C173.286 299.084 173.293 299.015 173.277 298.949C173.262 298.882 173.225 298.823 173.172 298.781L171.869 297.746L172.015 297.052C172.544 295.335 173.554 293.806 174.925 292.645C174.977 292.589 175.006 292.515 175.006 292.438C175.006 292.361 174.977 292.287 174.925 292.231C174.867 292.178 174.791 292.148 174.712 292.148C174.633 292.148 174.557 292.178 174.499 292.231C173.025 293.473 171.946 295.119 171.394 296.967L171.212 297.843C171.204 297.897 171.211 297.952 171.23 298.003C171.249 298.054 171.28 298.1 171.321 298.135L172.539 299.122C172.373 299.416 172.109 299.644 171.794 299.766C171.479 299.888 171.131 299.897 170.81 299.791C170.773 299.776 170.734 299.768 170.694 299.768C170.654 299.768 170.615 299.776 170.578 299.792C170.542 299.808 170.509 299.832 170.482 299.861C170.455 299.89 170.434 299.924 170.42 299.962C170.415 300.012 170.419 300.062 170.434 300.111C170.448 300.159 170.473 300.203 170.506 300.242Z",
    fill: "url(#paint1_linear_291_4339)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M171.295 290.672L169.152 290.271",
    stroke: "#845D42",
    strokeWidth: 0.82,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M178.37 296.041L177.627 294.665",
    stroke: "#845D42",
    strokeWidth: 0.82,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M166.997 281.529C167.304 281.507 167.613 281.558 167.897 281.679C168.18 281.799 168.431 281.986 168.628 282.223L168.847 281.846C169.047 281.507 169.312 281.211 169.626 280.974C169.94 280.737 170.298 280.565 170.679 280.466C171.06 280.368 171.457 280.345 171.847 280.401C172.236 280.456 172.611 280.587 172.95 280.787L179.123 284.439C179.444 284.626 179.827 284.679 180.187 284.585C180.547 284.492 180.856 284.26 181.046 283.94L182.008 282.321C182.547 283.071 182.774 284 182.641 284.914C183.041 284.313 183.36 283.662 183.591 282.978C183.591 282.978 185.624 287.385 183.384 290.283C182.745 291.111 181.827 291.678 180.8 291.877C179.774 292.077 178.71 291.895 177.808 291.366L169.931 286.728C169.717 286.601 169.48 286.517 169.233 286.482C168.987 286.447 168.736 286.461 168.495 286.523C168.254 286.585 168.028 286.695 167.829 286.845C167.63 286.995 167.463 287.183 167.338 287.398L164.416 292.353C164.13 292.858 163.664 293.237 163.111 293.413C162.558 293.589 161.958 293.549 161.433 293.302C161.167 293.162 160.932 292.97 160.742 292.737C160.553 292.504 160.412 292.235 160.329 291.946C160.246 291.657 160.222 291.354 160.259 291.056C160.296 290.757 160.393 290.47 160.544 290.21L164.915 282.808C165.126 282.436 165.428 282.124 165.792 281.901C166.156 281.677 166.57 281.55 166.997 281.529Z",
    fill: "#68584C"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M161.703 292.376C161.479 292.752 161.149 293.054 160.754 293.242C160.358 293.431 159.916 293.498 159.483 293.435C159.05 293.373 158.645 293.183 158.319 292.891C157.994 292.598 157.762 292.216 157.653 291.792C157.545 291.368 157.564 290.921 157.709 290.508C157.854 290.095 158.118 289.734 158.468 289.471C158.818 289.208 159.238 289.054 159.675 289.03C160.112 289.005 160.547 289.111 160.924 289.333C161.177 289.48 161.398 289.676 161.574 289.909C161.751 290.142 161.879 290.408 161.951 290.691C162.024 290.975 162.039 291.269 161.997 291.559C161.954 291.848 161.854 292.126 161.703 292.376Z",
    fill: "#FCB28D"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M160.923 291.342C160.947 291.101 160.898 290.858 160.783 290.645C160.668 290.431 160.491 290.257 160.276 290.145C160.062 290.032 159.818 289.987 159.577 290.013C159.336 290.04 159.108 290.138 158.924 290.295C158.739 290.452 158.605 290.661 158.539 290.894C158.474 291.128 158.48 291.376 158.556 291.606C158.632 291.836 158.775 292.038 158.967 292.187C159.159 292.335 159.391 292.422 159.633 292.438C159.948 292.459 160.259 292.356 160.5 292.151C160.74 291.947 160.892 291.657 160.923 291.342Z",
    fill: "url(#paint2_linear_291_4339)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M135.029 350.535C135.267 350.656 135.527 350.728 135.794 350.746C136.06 350.764 136.328 350.729 136.58 350.641C136.832 350.554 137.065 350.416 137.262 350.237C137.46 350.057 137.62 349.84 137.732 349.597L140.435 344.581C140.587 344.334 140.687 344.058 140.727 343.771C140.767 343.483 140.747 343.191 140.668 342.911C140.589 342.632 140.453 342.372 140.268 342.148C140.083 341.924 139.854 341.741 139.595 341.611L139.047 341.392C138.532 341.221 137.97 341.259 137.482 341.498C136.995 341.737 136.621 342.158 136.441 342.67L134.299 347.905C134.088 348.359 134.047 348.872 134.18 349.354C134.314 349.836 134.615 350.254 135.029 350.535Z",
    fill: "#FCB28D"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M138.486 342.913C136.286 336.441 136.654 329.372 139.512 323.163C142.371 316.955 147.503 312.079 153.851 309.543",
    stroke: "#FCB28D",
    strokeWidth: 3.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M156.492 308.484C156.208 307.797 155.669 307.247 154.988 306.95C154.307 306.653 153.537 306.631 152.84 306.889C146.088 309.587 140.569 314.681 137.341 321.196C134.113 327.711 133.402 335.188 135.345 342.195L140.666 340.028C139.276 334.438 139.957 328.534 142.585 323.408C145.213 318.283 149.609 314.282 154.958 312.148C155.647 311.866 156.198 311.327 156.494 310.644C156.789 309.962 156.806 309.191 156.541 308.496L156.492 308.484Z",
    fill: "#FF8578"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M283.446 233.659C258.623 261.161 199.09 233.501 211.398 183.05",
    stroke: "#DD8262",
    strokeWidth: 8.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M279.502 230.056C276.817 233.047 273.486 235.387 269.762 236.898C265.968 238.412 261.916 239.172 257.831 239.138C247.081 238.918 236.785 234.764 228.892 227.462C224.7 223.683 221.309 219.1 218.922 213.985C216.384 208.457 215.088 202.44 215.123 196.357C215.138 192.302 215.641 188.263 216.621 184.328C216.788 183.643 216.818 182.932 216.71 182.235C216.603 181.538 216.359 180.87 215.992 180.267C215.626 179.664 215.145 179.14 214.576 178.723C214.007 178.307 213.361 178.006 212.676 177.839C211.991 177.672 211.28 177.642 210.583 177.75C209.886 177.857 209.217 178.101 208.615 178.468C208.012 178.834 207.488 179.315 207.071 179.884C206.655 180.453 206.354 181.099 206.187 181.784C204.995 186.562 204.39 191.468 204.385 196.393C204.351 204.021 205.988 211.563 209.182 218.49C213.547 227.735 220.413 235.575 229.002 241.121C237.59 246.668 247.56 249.7 257.782 249.876C263.257 249.91 268.686 248.881 273.768 246.844C278.997 244.73 283.677 241.454 287.452 237.263C287.925 236.739 288.29 236.128 288.527 235.463C288.764 234.798 288.868 234.093 288.832 233.388C288.796 232.683 288.622 231.992 288.32 231.355C288.017 230.717 287.592 230.145 287.068 229.672C286.545 229.199 285.933 228.833 285.268 228.597C284.603 228.36 283.898 228.256 283.193 228.292C282.488 228.327 281.797 228.502 281.16 228.804C280.522 229.107 279.951 229.532 279.477 230.056H279.502Z",
    fill: "#F7A379"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M288.122 228.535C287.45 227.927 286.665 227.458 285.811 227.155C284.958 226.851 284.053 226.719 283.149 226.765C282.244 226.811 281.357 227.035 280.54 227.425C279.722 227.814 278.989 228.361 278.382 229.034C275.841 231.852 272.694 234.058 269.178 235.486C265.541 236.927 261.659 237.647 257.747 237.605C256.967 237.605 256.176 237.605 255.385 237.507V251.325C256.2 251.325 257.016 251.41 257.82 251.41C263.495 251.452 269.123 250.385 274.389 248.269C279.832 246.064 284.703 242.65 288.633 238.286C289.856 236.924 290.489 235.133 290.393 233.305C290.297 231.477 289.48 229.761 288.122 228.535Z",
    fill: "#C71B54"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M283.739 462.904H254.789C254.358 462.906 253.932 462.822 253.533 462.658C253.135 462.494 252.774 462.253 252.469 461.948C252.165 461.644 251.924 461.282 251.76 460.884C251.596 460.486 251.512 460.06 251.514 459.629C251.513 458.875 251.773 458.144 252.25 457.56C252.728 456.977 253.392 456.576 254.131 456.427L285.066 450.084C285.543 449.987 286.035 449.996 286.507 450.113C286.98 450.229 287.42 450.449 287.796 450.757C288.173 451.065 288.476 451.452 288.684 451.892C288.892 452.332 289 452.812 288.999 453.298V457.645C288.999 459.039 288.445 460.377 287.458 461.364C286.472 462.35 285.134 462.904 283.739 462.904Z",
    fill: "#DD8262"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M282.924 335.316V452.118",
    stroke: "#B3B3B3",
    strokeWidth: 10.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M247.167 461.638V461.455C247.134 459.614 247.83 457.835 249.102 456.503C250.374 455.172 252.12 454.397 253.96 454.346C256.049 454.341 258.135 454.203 260.206 453.932C262.811 453.518 266.585 449.244 268.728 446.956C270.871 444.667 273.415 444.156 274.146 445.799C274.96 447.319 276.144 448.609 277.589 449.549C279.034 450.49 280.693 451.051 282.412 451.18C283.976 451.258 285.531 450.909 286.912 450.171C288.293 449.434 289.447 448.335 290.253 446.992C290.484 446.359 290.849 446.493 290.849 446.493C293.381 446.493 293.284 449.792 293.284 449.792V461.638H247.167Z",
    fill: "#297DB5"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M293.346 461.639V464.232C293.346 464.519 293.232 464.795 293.029 464.998C292.826 465.201 292.55 465.315 292.263 465.315H249.251C247.071 464.841 247.108 462.333 247.169 461.663L293.346 461.639Z",
    fill: "#ED2064"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M293.346 462.211H247.168C247.093 462.211 247.018 462.196 246.949 462.167C246.88 462.139 246.816 462.096 246.763 462.043C246.71 461.99 246.668 461.927 246.639 461.858C246.611 461.788 246.596 461.714 246.596 461.639C246.596 461.563 246.611 461.489 246.639 461.42C246.668 461.35 246.71 461.287 246.763 461.234C246.816 461.181 246.88 461.139 246.949 461.11C247.018 461.081 247.093 461.066 247.168 461.066H293.346C293.421 461.066 293.495 461.081 293.565 461.11C293.634 461.139 293.697 461.181 293.75 461.234C293.803 461.287 293.845 461.35 293.874 461.42C293.903 461.489 293.918 461.563 293.918 461.639C293.918 461.714 293.903 461.788 293.874 461.858C293.845 461.927 293.803 461.99 293.75 462.043C293.697 462.096 293.634 462.139 293.565 462.167C293.495 462.196 293.421 462.211 293.346 462.211Z",
    fill: "#96C9E0"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M290.606 442.171V335.316C290.647 334.282 290.479 333.251 290.112 332.284C289.745 331.316 289.186 330.433 288.469 329.687C287.752 328.941 286.892 328.348 285.94 327.942C284.989 327.537 283.965 327.328 282.93 327.328C281.896 327.328 280.872 327.537 279.92 327.942C278.968 328.348 278.108 328.941 277.391 329.687C276.674 330.433 276.115 331.316 275.748 332.284C275.381 333.251 275.213 334.282 275.254 335.316V442.171H290.606Z",
    fill: "#028FA6"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M389.437 412.843L398.361 440.382C398.496 440.791 398.548 441.223 398.515 441.652C398.482 442.082 398.364 442.501 398.168 442.884C397.972 443.268 397.702 443.609 397.374 443.888C397.046 444.167 396.665 444.378 396.255 444.509C395.538 444.742 394.762 444.72 394.059 444.447C393.356 444.175 392.768 443.667 392.396 443.012L376.837 415.534C376.596 415.111 376.453 414.64 376.417 414.155C376.381 413.669 376.454 413.182 376.63 412.729C376.806 412.275 377.081 411.867 377.435 411.533C377.789 411.199 378.212 410.948 378.675 410.798L382.815 409.459C383.472 409.245 384.164 409.162 384.853 409.216C385.542 409.271 386.214 409.46 386.829 409.775C387.445 410.089 387.992 410.522 388.439 411.049C388.887 411.576 389.226 412.185 389.437 412.843Z",
    fill: "#DD8262"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M381.756 415.083C360.288 413.199 340.447 402.865 326.598 386.353C312.749 369.842 306.025 348.505 307.906 327.037",
    stroke: "#B3B3B3",
    strokeWidth: 10.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M294.271 347.503C293.723 347.503 293.163 347.503 292.603 347.43C287.134 346.998 282.061 344.413 278.497 340.242C274.934 336.071 273.172 330.656 273.599 325.187C275.702 298.959 274.512 272.57 270.056 246.638C269.593 243.956 269.663 241.21 270.261 238.556C270.86 235.902 271.975 233.392 273.544 231.169C275.112 228.945 277.103 227.053 279.403 225.599C281.703 224.146 284.267 223.159 286.948 222.697C289.629 222.234 292.375 222.303 295.029 222.902C297.683 223.5 300.194 224.616 302.417 226.184C304.64 227.753 306.532 229.744 307.986 232.044C309.44 234.344 310.426 236.907 310.889 239.589C315.939 268.929 317.289 298.786 314.907 328.462C314.49 333.649 312.136 338.488 308.311 342.017C304.487 345.546 299.474 347.504 294.271 347.503Z",
    fill: "#02A7C2"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M205.421 163.961C206.036 163.711 206.694 163.585 207.357 163.59C208.021 163.595 208.677 163.731 209.287 163.99C209.898 164.249 210.452 164.626 210.917 165.099C211.381 165.573 211.748 166.133 211.996 166.749L216.926 179.021C217.192 179.68 217.314 180.389 217.285 181.1C217.257 181.81 217.078 182.506 216.76 183.143C216.443 183.779 215.994 184.341 215.443 184.791C214.893 185.241 214.253 185.569 213.566 185.753L212.056 186.167C210.767 186.513 209.392 186.333 208.235 185.667C207.077 185 206.232 183.902 205.884 182.612L202.463 169.939C202.143 168.753 202.267 167.491 202.812 166.39C203.357 165.29 204.285 164.426 205.421 163.961Z",
    fill: "#F7A379"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M398.132 445.787H397.949C396.161 446.226 394.272 445.939 392.693 444.991C391.115 444.042 389.976 442.508 389.525 440.723C389.057 438.691 388.464 436.69 387.747 434.733C386.773 432.298 381.782 429.534 379.055 427.891C376.327 426.247 375.293 423.934 376.741 422.863C378.045 421.736 379.042 420.298 379.64 418.682C380.238 417.067 380.418 415.326 380.162 413.622C379.898 412.078 379.219 410.635 378.199 409.448C377.178 408.26 375.854 407.371 374.367 406.878C373.698 406.792 373.747 406.403 373.747 406.403C373.186 403.968 376.437 403.31 376.437 403.31L387.991 400.705L398.132 445.787Z",
    fill: "#297DB5"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M387.988 400.729L388.658 400.583L390.508 400.157C390.647 400.126 390.791 400.124 390.931 400.149C391.072 400.174 391.205 400.226 391.325 400.303C391.445 400.38 391.549 400.48 391.63 400.597C391.711 400.714 391.769 400.846 391.799 400.985L401.258 442.95C401.258 445.166 398.824 445.689 398.13 445.787L387.988 400.729Z",
    fill: "#ED2064"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M388.55 400.669L398.691 445.714C398.707 445.788 398.708 445.864 398.695 445.938C398.682 446.012 398.654 446.082 398.613 446.146C398.572 446.209 398.52 446.264 398.458 446.307C398.396 446.349 398.326 446.38 398.253 446.396C398.179 446.412 398.103 446.413 398.029 446.4C397.955 446.386 397.885 446.359 397.821 446.318C397.758 446.277 397.703 446.224 397.66 446.163C397.617 446.101 397.587 446.031 397.571 445.957L387.418 400.912C387.388 400.762 387.417 400.607 387.498 400.478C387.58 400.349 387.708 400.256 387.856 400.218C387.93 400.2 388.008 400.197 388.083 400.21C388.159 400.222 388.231 400.25 388.295 400.291C388.36 400.331 388.416 400.385 388.46 400.448C388.503 400.511 388.534 400.581 388.55 400.656",
    fill: "#96C9E0"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M371.626 405.673C355.579 401.809 341.296 392.663 331.073 379.705C320.85 366.746 315.28 350.727 315.258 334.221C315.258 332.066 315.356 329.875 315.55 327.708C315.726 325.681 315.09 323.666 313.782 322.107C312.474 320.548 310.601 319.572 308.574 319.393H307.893C305.97 319.383 304.116 320.101 302.7 321.401C301.285 322.702 300.413 324.489 300.259 326.405C300.028 328.998 299.906 331.652 299.906 334.258C299.919 354.434 306.796 374.006 319.408 389.755C332.02 405.504 349.615 416.493 369.301 420.915L371.626 405.673Z",
    fill: "#02A7C2"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M272.49 319.355H317.049C318.51 292.587 316.95 265.739 312.398 239.32C311.207 233.685 307.877 228.73 303.109 225.499C298.341 222.267 292.505 221.011 286.829 221.993C281.153 222.975 276.08 226.12 272.674 230.766C269.269 235.412 267.798 241.197 268.57 246.905C272.685 270.821 274 295.135 272.49 319.355Z",
    fill: "#ED2064"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M274.926 166.079C270.901 166.666 267.256 168.781 264.748 171.984C264.769 170.462 265.189 168.972 265.965 167.662C267.816 164.399 271.115 162.792 273.331 164.01C274.111 164.466 274.683 165.209 274.926 166.079Z",
    fill: "#2D2620"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M290.12 224.954L288.172 209.639C288.096 209.039 287.902 208.459 287.602 207.934C287.302 207.408 286.902 206.947 286.424 206.576C285.946 206.205 285.399 205.932 284.815 205.772C284.232 205.613 283.622 205.57 283.022 205.646C282.421 205.722 281.842 205.915 281.316 206.215C280.791 206.515 280.329 206.915 279.959 207.394C279.588 207.872 279.315 208.418 279.155 209.002C278.996 209.586 278.953 210.195 279.029 210.796L280.977 226.123C281.172 227.306 281.82 228.366 282.783 229.08C283.747 229.793 284.95 230.103 286.138 229.945C287.326 229.787 288.406 229.172 289.149 228.232C289.893 227.291 290.24 226.098 290.12 224.906V224.954Z",
    fill: "url(#paint3_linear_291_4339)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M262.519 218.125L259.086 216.177C255.081 213.899 252.144 210.125 250.918 205.683C249.692 201.241 250.279 196.495 252.548 192.485L264.187 171.984C265.143 170.296 266.423 168.813 267.953 167.619C269.483 166.426 271.232 165.546 273.102 165.029C274.973 164.513 276.926 164.37 278.851 164.608C280.777 164.847 282.636 165.462 284.324 166.42L293.856 171.837C295.545 172.793 297.029 174.072 298.224 175.601C299.418 177.131 300.298 178.881 300.815 180.752C301.332 182.622 301.475 184.576 301.235 186.502C300.996 188.427 300.379 190.287 299.42 191.974L288.658 210.93C286.145 215.349 281.98 218.59 277.078 219.939C272.176 221.288 266.94 220.636 262.519 218.125Z",
    fill: "#FCB28D"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M263.054 185.278C262.525 185.213 262.013 185.045 261.55 184.781C261.086 184.518 260.679 184.166 260.352 183.744",
    stroke: "#D8654E",
    strokeWidth: 0.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M277.664 193.569C277.134 193.504 276.623 193.336 276.159 193.072C275.695 192.809 275.288 192.457 274.961 192.035",
    stroke: "#D8654E",
    strokeWidth: 0.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M265.684 203.881C265.152 204.293 264.544 204.596 263.894 204.77C263.241 204.95 262.559 205.003 261.885 204.928C261.188 204.843 260.514 204.624 259.901 204.283C259.292 203.931 258.758 203.464 258.33 202.907C257.915 202.373 257.613 201.76 257.442 201.105C257.261 200.456 257.208 199.778 257.283 199.108",
    stroke: "#D8654E",
    strokeWidth: 1.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M265.389 179.372L264.891 179.09C264.47 178.851 263.935 178.999 263.696 179.42L262.098 182.236C261.859 182.657 262.006 183.192 262.427 183.431L262.925 183.713C263.346 183.952 263.881 183.805 264.12 183.384L265.718 180.567C265.957 180.146 265.81 179.611 265.389 179.372Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M279.678 187.458L279.18 187.176C278.759 186.937 278.224 187.085 277.986 187.506L276.388 190.323C276.149 190.744 276.297 191.279 276.718 191.517L277.216 191.8C277.637 192.039 278.172 191.891 278.411 191.47L280.008 188.653C280.247 188.232 280.099 187.697 279.678 187.458Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M262.848 195.772C262.687 195.776 262.531 195.719 262.41 195.614C259.841 193.495 260.852 190.403 261.74 189.064C261.825 188.932 261.952 188.834 262.101 188.785C262.249 188.737 262.41 188.74 262.556 188.796L266.208 190.22L267.426 189.137C270.266 186.085 272.171 182.282 272.916 178.18C272.931 178.091 272.963 178.007 273.011 177.931C273.059 177.855 273.122 177.789 273.196 177.738C273.27 177.687 273.353 177.651 273.441 177.633C273.529 177.615 273.62 177.614 273.708 177.632C273.797 177.647 273.882 177.679 273.958 177.727C274.035 177.775 274.101 177.837 274.153 177.911C274.205 177.984 274.242 178.068 274.262 178.156C274.281 178.244 274.283 178.335 274.268 178.423C273.489 182.827 271.431 186.905 268.351 190.147L266.805 191.523C266.71 191.607 266.594 191.663 266.469 191.684C266.344 191.706 266.216 191.692 266.099 191.645L262.666 190.293C262.262 190.97 262.108 191.767 262.23 192.545C262.352 193.323 262.743 194.034 263.335 194.554C263.441 194.646 263.516 194.768 263.551 194.903C263.587 195.039 263.58 195.182 263.533 195.313C263.485 195.445 263.399 195.559 263.286 195.641C263.172 195.723 263.037 195.769 262.897 195.772H262.848Z",
    fill: "url(#paint4_linear_291_4339)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M281.146 183.11L284.446 186.945",
    stroke: "#845D42",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M262.166 175.112L265.794 175.002",
    stroke: "#845D42",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M304.511 181.176C304.203 180.535 303.745 179.978 303.174 179.554C302.604 179.13 301.938 178.851 301.236 178.741L301.711 177.877C302.163 177.081 302.453 176.205 302.566 175.297C302.679 174.389 302.612 173.468 302.369 172.586C302.126 171.704 301.712 170.879 301.15 170.157C300.587 169.436 299.889 168.832 299.093 168.38L284.666 160.126C283.916 159.695 283.367 158.984 283.138 158.149C282.91 157.315 283.022 156.423 283.449 155.67L285.604 151.872H285.543C283.416 151.663 281.29 152.277 279.602 153.589C280.346 152.09 281.288 150.697 282.402 149.449C282.402 149.449 271.177 150.472 267.902 158.349C266.984 160.596 266.916 163.1 267.709 165.394C268.502 167.688 270.102 169.615 272.212 170.815L290.632 181.273C291.136 181.558 291.578 181.939 291.934 182.395C292.29 182.851 292.552 183.373 292.706 183.93C292.86 184.488 292.902 185.071 292.83 185.645C292.758 186.219 292.574 186.773 292.288 187.275L285.713 198.865C285.028 200.026 284.807 201.404 285.096 202.721C285.386 204.038 286.163 205.196 287.272 205.963C287.858 206.34 288.514 206.593 289.201 206.707C289.888 206.82 290.591 206.793 291.267 206.625C291.943 206.458 292.578 206.154 293.132 205.732C293.687 205.31 294.149 204.78 294.491 204.173L304.34 186.825C304.84 185.973 305.117 185.009 305.147 184.022C305.177 183.035 304.958 182.056 304.511 181.176Z",
    fill: "#68584C"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M288.914 204.478C288.41 205.363 288.18 206.379 288.254 207.395C288.327 208.411 288.7 209.383 289.326 210.187C289.952 210.991 290.803 211.592 291.77 211.912C292.737 212.233 293.778 212.259 294.76 211.988C295.743 211.717 296.622 211.16 297.288 210.389C297.954 209.618 298.376 208.666 298.501 207.655C298.626 206.643 298.448 205.618 297.989 204.708C297.531 203.797 296.813 203.044 295.926 202.542C294.739 201.87 293.334 201.697 292.02 202.06C290.705 202.423 289.588 203.292 288.914 204.478Z",
    fill: "#FCB28D"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M291.812 204.745C292.261 204.434 292.792 204.262 293.339 204.252C293.885 204.243 294.422 204.395 294.882 204.691C295.342 204.986 295.704 205.411 295.922 205.913C296.14 206.414 296.204 206.968 296.107 207.506C296.01 208.044 295.756 208.541 295.377 208.934C294.997 209.328 294.51 209.6 293.976 209.716C293.442 209.832 292.885 209.787 292.376 209.587C291.868 209.387 291.43 209.041 291.118 208.592C290.703 207.989 290.543 207.246 290.673 206.526C290.803 205.805 291.212 205.165 291.812 204.745Z",
    fill: "url(#paint5_linear_291_4339)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M293.607 190.533L276.307 180.713L275.724 181.74L293.024 191.56L293.607 190.533Z",
    fill: "#51395D"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M303.133 233.221L356.92 330.933",
    stroke: "#FCB28D",
    strokeWidth: 8.82,
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M372.966 341.5C372.624 342.068 372.173 342.562 371.639 342.954C371.105 343.347 370.499 343.631 369.856 343.789C369.213 343.947 368.544 343.977 367.889 343.877C367.234 343.777 366.606 343.548 366.039 343.205L354.729 336.338C354.121 335.97 353.598 335.477 353.194 334.891C352.791 334.305 352.516 333.641 352.388 332.941C352.261 332.242 352.283 331.523 352.453 330.833C352.624 330.142 352.939 329.496 353.378 328.936L354.339 327.719C355.163 326.67 356.368 325.99 357.691 325.828C359.015 325.666 360.349 326.035 361.4 326.855L371.749 334.951C372.712 335.709 373.366 336.791 373.59 337.996C373.814 339.201 373.592 340.447 372.966 341.5Z",
    fill: "#FCB28D"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M306.958 254.502L318.925 247.599L309.186 229.885C308.303 228.281 306.818 227.092 305.059 226.582C303.3 226.072 301.41 226.281 299.805 227.164C298.2 228.047 297.012 229.532 296.502 231.291C295.992 233.05 296.201 234.94 297.084 236.545L306.958 254.502Z",
    fill: "#C71B54"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M276.897 182.307L277.25 181.711L270.457 177.742L270.104 178.351L254.484 169.22L249.359 178.083C249.101 178.527 249.029 179.056 249.159 179.553C249.289 180.05 249.61 180.475 250.052 180.737L263.615 188.65C263.834 188.779 264.076 188.863 264.327 188.898C264.579 188.933 264.835 188.918 265.08 188.854C265.326 188.789 265.556 188.676 265.758 188.522C265.96 188.368 266.13 188.176 266.257 187.956L270.006 181.528L274.657 184.243L270.907 190.659C270.778 190.879 270.693 191.122 270.658 191.374C270.623 191.627 270.639 191.884 270.703 192.13C270.767 192.377 270.88 192.608 271.034 192.811C271.188 193.014 271.381 193.185 271.601 193.313L285.164 201.226C285.606 201.484 286.133 201.555 286.628 201.425C287.123 201.295 287.546 200.974 287.805 200.532L292.98 191.669L276.897 182.307Z",
    fill: "url(#paint6_linear_291_4339)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M256.772 170.554L254.498 169.208L251.714 173.912L253.987 175.258L256.772 170.554Z",
    fill: "#6166AF"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M253.01 172.556C252.897 172.762 252.869 173.004 252.93 173.23C252.991 173.457 253.137 173.651 253.338 173.773L254.276 172.19C254.169 172.129 254.051 172.089 253.929 172.074C253.807 172.059 253.683 172.069 253.565 172.103C253.447 172.137 253.336 172.195 253.241 172.273C253.146 172.35 253.067 172.447 253.01 172.556Z",
    fill: "#999999"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M254.228 172.239L253.291 173.822C253.499 173.916 253.734 173.93 253.951 173.862C254.168 173.793 254.353 173.647 254.469 173.451C254.585 173.255 254.625 173.023 254.58 172.799C254.536 172.575 254.411 172.376 254.228 172.239Z",
    fill: "#E6E6E6"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M271.771 178.603L254.592 168.572L253.996 169.592L271.175 179.623L271.771 178.603Z",
    fill: "#51395D"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M293.365 191.218L276.186 181.188L275.59 182.207L292.769 192.238L293.365 191.218Z",
    fill: "#51395D"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M253.425 172.836C253.478 172.745 253.566 172.678 253.669 172.65C253.771 172.623 253.881 172.637 253.973 172.69C254.017 172.717 254.055 172.751 254.086 172.793C254.116 172.834 254.138 172.881 254.151 172.93C254.163 172.98 254.166 173.032 254.158 173.083C254.151 173.133 254.133 173.182 254.107 173.226C254.055 173.316 253.969 173.383 253.869 173.41C253.769 173.437 253.661 173.424 253.571 173.372C253.48 173.32 253.414 173.235 253.387 173.135C253.359 173.034 253.373 172.927 253.425 172.836Z",
    fill: "#333333"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M254.449 171.107C254.475 171.063 254.51 171.024 254.551 170.994C254.592 170.963 254.639 170.941 254.689 170.929C254.738 170.916 254.79 170.914 254.841 170.921C254.892 170.929 254.94 170.946 254.984 170.973C255.029 170.998 255.069 171.032 255.101 171.073C255.132 171.114 255.156 171.16 255.169 171.21C255.183 171.26 255.187 171.312 255.18 171.363C255.173 171.415 255.156 171.464 255.13 171.509C255.075 171.598 254.986 171.663 254.884 171.688C254.781 171.713 254.673 171.697 254.582 171.643C254.538 171.616 254.5 171.582 254.469 171.54C254.439 171.499 254.417 171.452 254.404 171.403C254.392 171.353 254.389 171.301 254.397 171.25C254.404 171.2 254.422 171.151 254.449 171.107Z",
    fill: "#333333"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M358.504 232.928V168.659",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.82 2.87"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M386.091 116.2H328.359V164.472H386.091V116.2Z",
    fill: "url(#paint7_linear_291_4339)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M386.091 162.146V164.472H383.766",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M380.221 164.473H332.461",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M330.697 164.472H328.359V162.146",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M328.359 158.701V120.254",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M328.359 118.526V116.2H330.697",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M334.229 116.2H382.001",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M383.766 116.2H386.091V118.526",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M386.09 121.971V160.418",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M376.424 137.7C376.11 137.699 375.809 137.577 375.584 137.359C370.712 132.494 364.109 129.761 357.224 129.761C350.34 129.761 343.737 132.494 338.865 137.359C338.632 137.507 338.355 137.571 338.08 137.541C337.805 137.511 337.548 137.387 337.353 137.192C337.157 136.996 337.034 136.74 337.003 136.465C336.973 136.19 337.037 135.913 337.185 135.679C342.504 130.371 349.71 127.39 357.224 127.39C364.738 127.39 371.945 130.371 377.264 135.679C377.479 135.905 377.6 136.206 377.6 136.519C377.6 136.832 377.479 137.133 377.264 137.359C377.038 137.577 376.737 137.699 376.424 137.7Z",
    fill: "#00A6FF"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M371.42 142.728C371.104 142.724 370.803 142.597 370.579 142.375C367.035 138.838 362.232 136.851 357.224 136.851C352.216 136.851 347.413 138.838 343.869 142.375C343.771 142.529 343.64 142.66 343.485 142.756C343.33 142.853 343.156 142.913 342.974 142.934C342.793 142.954 342.609 142.933 342.437 142.872C342.265 142.812 342.109 142.713 341.98 142.584C341.851 142.455 341.752 142.299 341.692 142.127C341.631 141.955 341.61 141.771 341.63 141.59C341.651 141.408 341.711 141.234 341.808 141.079C341.904 140.924 342.035 140.793 342.189 140.695C346.179 136.712 351.586 134.475 357.224 134.475C362.862 134.475 368.27 136.712 372.26 140.695C372.414 140.866 372.517 141.077 372.557 141.304C372.596 141.531 372.57 141.764 372.482 141.977C372.394 142.19 372.248 142.374 372.06 142.507C371.872 142.64 371.65 142.717 371.42 142.728Z",
    fill: "#00A6FF"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M366.416 147.733C366.101 147.728 365.8 147.602 365.576 147.38C363.36 145.171 360.359 143.931 357.23 143.931C354.102 143.931 351.101 145.171 348.885 147.38C348.651 147.528 348.374 147.592 348.099 147.561C347.824 147.531 347.568 147.408 347.372 147.212C347.177 147.017 347.053 146.76 347.023 146.485C346.993 146.21 347.057 145.933 347.205 145.699C349.866 143.045 353.472 141.554 357.23 141.554C360.989 141.554 364.595 143.045 367.256 145.699C367.411 145.87 367.514 146.081 367.553 146.308C367.593 146.535 367.567 146.769 367.479 146.982C367.391 147.195 367.244 147.378 367.056 147.511C366.868 147.644 366.646 147.721 366.416 147.733Z",
    fill: "#00A6FF"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M361.548 153.527C361.548 154.382 361.295 155.217 360.82 155.928C360.345 156.639 359.67 157.193 358.88 157.52C358.09 157.847 357.221 157.933 356.383 157.766C355.545 157.599 354.775 157.188 354.17 156.583C353.566 155.979 353.154 155.209 352.987 154.37C352.821 153.532 352.906 152.663 353.233 151.873C353.56 151.083 354.114 150.408 354.825 149.933C355.536 149.459 356.371 149.205 357.226 149.205C358.372 149.205 359.472 149.66 360.282 150.471C361.093 151.281 361.548 152.381 361.548 153.527Z",
    fill: "#00A6FF"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4366 299.767H36.1113",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6539 299.767H21.8795C18.9423 299.764 16.1262 298.596 14.0492 296.519C11.9723 294.442 10.804 291.626 10.8008 288.688V272.253C10.8008 269.315 11.968 266.497 14.0457 264.419C16.1233 262.341 18.9413 261.174 21.8795 261.174H57.1854C58.6408 261.176 60.0821 260.89 61.427 260.334C62.7719 259.778 63.9938 258.962 65.0229 257.933C66.052 256.904 66.8679 255.682 67.4241 254.337C67.9803 252.992 68.2658 251.551 68.2642 250.095V234.195C68.2658 232.738 67.9795 231.295 67.4218 229.948C66.8641 228.602 66.0459 227.379 65.0143 226.349C63.9826 225.32 62.7578 224.504 61.4101 223.95C60.0625 223.395 58.6185 223.112 57.1611 223.117H40.5917C39.1347 223.12 37.6915 222.836 36.3445 222.28C34.9976 221.725 33.7734 220.909 32.7421 219.88C31.7107 218.851 30.8925 217.629 30.3342 216.283C29.7759 214.937 29.4886 213.495 29.4886 212.038V118.684C29.487 117.229 29.7724 115.788 30.3286 114.443C30.8848 113.098 31.7008 111.876 32.7299 110.847C33.759 109.818 34.9809 109.002 36.3258 108.446C37.6706 107.889 39.112 107.604 40.5673 107.605H65.7684",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.85 2.89"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5703 107.605H69.8956",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M127.626 80.2129H69.8945V128.485H127.626V80.2129Z",
    fill: "url(#paint8_linear_291_4339)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M127.626 126.158V128.484H125.301",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M121.76 128.483H74",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2199 128.484H69.8945V126.158",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8945 122.713V84.2539",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8945 82.5382V80.2129H72.2199",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7637 80.2129H123.536",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M125.301 80.2129H127.626V82.5382",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M127.627 85.9824V124.429",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7601 114.093C109.484 114.093 118.178 109.651 118.178 104.171C118.178 98.6913 109.484 94.249 98.7601 94.249C88.0357 94.249 79.3418 98.6913 79.3418 104.171C79.3418 109.651 88.0357 114.093 98.7601 114.093Z",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M85.002 117.892C81.1306 114.021 84.1376 104.732 91.7223 97.1959C99.307 89.6599 108.584 86.6163 112.419 90.4878C116.254 94.3593 113.283 103.648 105.711 111.184C98.1383 118.72 88.91 121.776 85.002 117.892Z",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7539 104.171C95.7515 103.573 95.9269 102.987 96.2577 102.489C96.5885 101.991 97.0599 101.602 97.6121 101.372C98.1643 101.142 98.7724 101.081 99.3592 101.197C99.946 101.313 100.485 101.601 100.908 102.024C101.331 102.447 101.619 102.986 101.735 103.573C101.851 104.16 101.79 104.768 101.56 105.32C101.33 105.872 100.941 106.344 100.443 106.674C99.9446 107.005 99.3592 107.181 98.761 107.178C97.9635 107.178 97.1986 106.861 96.6347 106.297C96.0707 105.733 95.7539 104.969 95.7539 104.171Z",
    fill: "#00A6FF"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M343.688 62.1818V59.8564",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M343.687 56.3263V41.7169C343.683 39.4039 342.762 37.1868 341.126 35.5524C339.489 33.918 337.27 33 334.957 33H297.131C294.816 33 292.596 33.9197 290.959 35.5567C289.322 37.1937 288.402 39.414 288.402 41.7291V50.653",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.86 2.9"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M288.402 52.3701V54.6954",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M300.747 57.6416H243.016V105.913H300.747V57.6416Z",
    fill: "url(#paint9_linear_291_4339)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 103.588V105.913H298.422",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M294.88 105.912H247.119",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M245.341 105.913H243.016V103.588",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M243.016 100.142V61.6953",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M243.016 59.9791V57.6416H245.341",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M248.883 57.6416H296.643",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M298.422 57.6416H300.747V59.9791",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M300.748 63.4121V101.871",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M260.76 87.7894V82.1082H261.724V87.7894H260.76ZM258.402 85.4309V84.4668H264.083V85.4309H258.402ZM269.249 80.5243V89.3389H268.181V81.6434H268.13L265.978 83.0723V81.9877L268.181 80.5243H269.249ZM274.538 89.4594C274.033 89.4594 273.578 89.359 273.174 89.1581C272.769 88.9572 272.445 88.6818 272.201 88.3317C271.957 87.9817 271.824 87.5828 271.801 87.1352H272.834C272.874 87.5341 273.055 87.864 273.376 88.1251C273.7 88.3834 274.088 88.5125 274.538 88.5125C274.9 88.5125 275.221 88.4279 275.502 88.2586C275.786 88.0893 276.009 87.8569 276.169 87.5613C276.333 87.2629 276.415 86.9258 276.415 86.5499C276.415 86.1654 276.33 85.8225 276.161 85.5212C275.994 85.2171 275.765 84.9775 275.472 84.8025C275.179 84.6274 274.845 84.5385 274.469 84.5356C274.2 84.5328 273.923 84.5744 273.639 84.6604C273.355 84.7437 273.121 84.8513 272.937 84.9832L271.939 84.8627L272.472 80.5243H277.052V81.4712H273.368L273.058 84.0708H273.109C273.29 83.9273 273.517 83.8083 273.789 83.7136C274.062 83.6189 274.346 83.5715 274.641 83.5715C275.181 83.5715 275.662 83.7007 276.083 83.9589C276.508 84.2143 276.841 84.5643 277.082 85.0091C277.326 85.4538 277.448 85.9617 277.448 86.5327C277.448 87.0951 277.321 87.5972 277.069 88.0391C276.819 88.4781 276.475 88.8253 276.036 89.0806C275.597 89.3331 275.098 89.4594 274.538 89.4594Z",
    fill: "#00A6FF"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M284.434 77.8017H283.63V77.5947C283.63 74.6887 282.476 71.9018 280.421 69.8469C278.366 67.7921 275.579 66.6377 272.673 66.6377C269.767 66.6377 266.981 67.7921 264.926 69.8469C262.871 71.9018 261.716 74.6887 261.716 77.5947V77.8017H259.282C256.747 77.8017 254.316 78.8086 252.524 80.6008C250.731 82.3931 249.725 84.824 249.725 87.3586C249.725 89.8933 250.731 92.3241 252.524 94.1164C254.316 95.9087 256.747 96.9156 259.282 96.9156H284.385C286.92 96.9156 289.351 95.9087 291.143 94.1164C292.935 92.3241 293.942 89.8933 293.942 87.3586C293.942 84.8324 292.942 82.4089 291.16 80.618C289.379 78.8271 286.96 77.8145 284.434 77.8017Z",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M448.582 291.244H450.907",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M454.451 291.244H466.297C468.024 291.246 469.734 290.907 471.33 290.248C472.925 289.589 474.376 288.622 475.598 287.402C476.82 286.182 477.79 284.733 478.452 283.139C479.114 281.544 479.456 279.835 479.458 278.108V155.316",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M479.443 153.539V151.214",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M506.313 97.7803H448.582V146.052H506.313V97.7803Z",
    fill: "url(#paint10_linear_291_4339)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M506.302 143.727V146.052H503.977",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M500.444 146.053H452.672",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M450.907 146.052H448.582V143.727",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M448.582 140.281V101.822",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M448.582 100.106V97.7803H450.907",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M454.451 97.7803H502.212",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M503.977 97.7803H506.302V100.106",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M506.301 103.551V141.998",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M467.195 125.149C467.195 119.634 477.191 108.238 477.191 108.238C477.191 108.238 487.174 119.634 487.174 125.149C487.083 127.738 485.991 130.19 484.128 131.99C482.264 133.789 479.775 134.795 477.184 134.795C474.594 134.795 472.105 133.789 470.241 131.99C468.378 130.19 467.286 127.738 467.195 125.149Z",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M152.463 316.251V313.926",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M152.461 310.419V292.742C152.463 291.566 152.233 290.401 151.784 289.314C151.335 288.227 150.676 287.239 149.845 286.407C149.014 285.575 148.027 284.914 146.94 284.464C145.854 284.013 144.689 283.782 143.513 283.782H134.784C132.411 283.782 130.135 282.839 128.457 281.161C126.779 279.483 125.836 277.207 125.836 274.833V257.266",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.85 2.89"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M125.836 255.513V253.188",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M152.938 201.653H95.207V249.925H152.938V201.653Z",
    fill: "url(#paint11_linear_291_4339)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M152.939 247.587V249.924H150.613",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M147.069 249.912H99.2969",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5324 249.924H95.207V247.587",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M95.207 244.153V205.694",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M95.207 203.979V201.653H97.5324",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M101.072 201.653H148.833",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M150.613 201.653H152.939V203.979",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M152.938 207.423V245.87",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M139.79 213.254C137.839 211.834 135.441 211.165 133.037 211.37C130.632 211.576 128.383 212.643 126.702 214.374L125.898 215.19L125.095 214.374C123.411 212.644 121.16 211.579 118.754 211.373C116.348 211.167 113.949 211.835 111.995 213.254C110.889 214.102 109.976 215.176 109.317 216.404C108.659 217.633 108.27 218.988 108.176 220.378C108.083 221.769 108.287 223.164 108.776 224.469C109.264 225.775 110.026 226.961 111.009 227.949L124.766 241.706C125.065 242.004 125.47 242.171 125.892 242.171C126.315 242.171 126.72 242.004 127.019 241.706L140.776 227.949C141.768 226.966 142.538 225.781 143.032 224.474C143.526 223.168 143.734 221.77 143.64 220.376C143.547 218.982 143.154 217.625 142.49 216.396C141.826 215.167 140.905 214.096 139.79 213.254Z",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M126.64 214.388L119.554 221.498L125.848 227.792L118.312 235.316",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M194.561 94.335H136.83V142.607H194.561V94.335Z",
    fill: "url(#paint12_linear_291_4339)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M194.55 140.281V142.607H192.225",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M188.68 142.607H140.92",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M139.144 142.607H136.818V140.281",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M136.83 136.836V98.3887",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M136.818 96.6603V94.335H139.144",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M142.688 94.335H190.46",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.88 2.91"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M192.225 94.335H194.55V96.6603",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M194.551 100.105V138.565",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.77 2.83"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M198.141 293.338V291.013",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M198.141 287.544V235.194C198.138 232.119 196.914 229.171 194.738 226.998C192.563 224.825 189.614 223.604 186.539 223.604H177.591C174.516 223.604 171.566 222.383 169.391 220.21C167.215 218.037 165.992 215.089 165.988 212.014V149.754",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.8 2.85"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M165.988 148.012V145.687",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M175.169 104.512C174.489 104.516 173.813 104.614 173.16 104.805C172.491 103.431 171.446 102.274 170.148 101.469C168.849 100.664 167.349 100.243 165.821 100.254C164.293 100.266 162.799 100.709 161.512 101.534C160.226 102.359 159.199 103.531 158.551 104.914C157.561 104.575 156.51 104.455 155.47 104.563C154.43 104.671 153.426 105.004 152.527 105.539C151.629 106.073 150.857 106.797 150.266 107.66C149.676 108.523 149.28 109.504 149.106 110.535C148.932 111.566 148.985 112.623 149.261 113.632C149.536 114.64 150.028 115.577 150.702 116.377C151.376 117.176 152.216 117.82 153.163 118.262C154.111 118.705 155.143 118.936 156.189 118.939C156.722 118.941 157.253 118.879 157.771 118.757V136.276H173.976V118.842C174.378 118.907 174.785 118.939 175.193 118.939C176.165 118.979 177.135 118.822 178.045 118.478C178.955 118.133 179.786 117.608 180.488 116.934C181.19 116.261 181.749 115.452 182.131 114.557C182.512 113.662 182.709 112.699 182.709 111.726C182.709 110.753 182.512 109.79 182.131 108.895C181.749 108 181.19 107.191 180.488 106.517C179.786 105.843 178.955 105.319 178.045 104.974C177.135 104.63 176.165 104.473 175.193 104.512H175.169Z",
    stroke: "#00A6FF",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M457.663 105.572L458.771 110.552L463.751 111.659L458.771 112.78L457.663 117.747L456.556 112.78L451.576 111.659L456.556 110.552L457.663 105.572Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M106.468 233.488L107.588 238.468L112.555 239.576L107.588 240.696L106.468 245.675L105.36 240.696L100.381 239.576L105.36 238.468L106.468 233.488Z",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M240.204 146.271L241.312 151.251L246.292 152.359L241.312 153.479L240.204 158.458L239.084 153.479L234.117 152.359L239.084 151.251L240.204 146.271Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M280.902 193.958L281.548 196.807L284.396 197.44L281.548 198.073L280.902 200.934L280.269 198.073L277.408 197.44L280.269 196.807L280.902 193.958Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M147.167 119.524L148.287 124.504L153.267 125.624L148.287 126.732L147.167 131.711L146.059 126.732L141.08 125.624L146.059 124.504L147.167 119.524Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M254.156 63.7041L255.276 68.6835L260.243 69.8035L255.276 70.9114L254.156 75.8907L253.048 70.9114L248.068 69.8035L253.048 68.6835L254.156 63.7041Z",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M80.888 83.4756L81.9959 88.4549L86.9752 89.5628L81.9959 90.6829L80.888 95.6622L79.768 90.6829L74.8008 89.5628L79.768 88.4549L80.888 83.4756Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M236.661 122.008L238.183 128.801L244.976 130.323L238.183 131.845L236.661 138.65L235.14 131.845L228.334 130.323L235.14 128.801L236.661 122.008Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_291_4339",
    x1: 164.794,
    y1: 300.449,
    x2: 158.256,
    y2: 306.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8654E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#DE7259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#EF9575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB28D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_291_4339",
    x1: 176.793,
    y1: 298.893,
    x2: 174.499,
    y2: 292.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8654E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E0765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4A17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FCB28D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_291_4339",
    x1: 163.505,
    y1: 290.903,
    x2: 166.178,
    y2: 292.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8654E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E0765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4A17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FCB28D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_291_4339",
    x1: 277.008,
    y1: 210.309,
    x2: 292.153,
    y2: 225.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8654E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#DE7259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#EF9575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB28D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_291_4339",
    x1: 258.27,
    y1: 188.36,
    x2: 273.84,
    y2: 185.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8654E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E0765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4A17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FCB28D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_291_4339",
    x1: 296.834,
    y1: 208.482,
    x2: 289.781,
    y2: 205.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8654E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E0765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4A17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FCB28D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_291_4339",
    x1: 249.042,
    y1: 185.363,
    x2: 292.931,
    y2: 185.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D52AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#956AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#609FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#36C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#19E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#06F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_291_4339",
    x1: 357.225,
    y1: 116.2,
    x2: 357.225,
    y2: 164.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D52AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#956AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#609FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#36C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#19E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#06F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_291_4339",
    x1: 98.7602,
    y1: 80.3712,
    x2: 98.7602,
    y2: 128.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D52AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#956AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#609FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#36C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#19E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#06F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_291_4339",
    x1: 271.881,
    y1: 57.6416,
    x2: 271.881,
    y2: 105.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D52AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#956AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#609FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#36C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#19E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#06F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_291_4339",
    x1: 477.448,
    y1: 97.7803,
    x2: 477.448,
    y2: 146.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D52AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#956AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#609FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#36C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#19E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#06F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_291_4339",
    x1: 124.073,
    y1: 201.653,
    x2: 124.073,
    y2: 249.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D52AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#956AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#609FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#36C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#19E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#06F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_291_4339",
    x1: 165.684,
    y1: 94.335,
    x2: 165.684,
    y2: 142.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D52AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#956AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#609FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#36C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#19E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#06F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlyAvailable);
export default __webpack_public_path__ + "static/media/HighlyAvailable.fe2d6fc154d7dc7d11622a7028ce9f9e.svg";
export { ForwardRef as ReactComponent };